import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { sweetAlert, sweetAlertWithHtml, sweetAlertWithInput, sweetAlertWithMultiSelector, sweetAlertWithSelector } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DispatchCenterService } from '../../dashboard/dashboard-service/dispatch-center-service';
import { downloadFile } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';
import { MenuService, UserRoles } from '../../shared/layout/menu-service/menu.service';
import { takeUntil, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Cms1500Service } from 'src/app/service/cms-service/cms1500.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../../reports/reports-service/report.service';
import { FilterByKeyPipe } from 'src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { environment } from 'src/environments/environment';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { exit } from 'process';
import { checkRole, hasOvertimeViolation, isNotCurrentDateTrip, legTypeMap, parseDisplayName } from 'src/app/utils/utils.common';
import { HolidayService } from 'src/app/component/extras/holidays/service/holiday.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { FarmoutService } from 'src/app/service/farmout-service/farmout.service';
import { ClassGetter } from '@angular/compiler/src/output/output_ast';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { TripPurposesService } from '../../trip-purposes/service/trip-purposes.service';
import { SweetAlertService } from '../../shared/sweet-select/sweet-alert.service';
import { Router } from '@angular/router';

@Component({
  selector: "app-unassigned",
  templateUrl: "./unassigned.component.html",
  styleUrls: ["./unassigned.component.css"],
})
export class UnassignedComponent implements OnInit, OnDestroy {
  @ViewChild("timer", { static: false }) timer;
  duration = 10 * 1000; // 10 seconds
  dataList = [];
  subMenus = [];
  filterdataList = [];
  duplicateTripIds = new Set<string>();
  todayDate;
  status = "";
  isShowAllTrips = false;
  showSlideFilter = false;
  isTimerEnabled = false;
  search: any;
  assignModalObj;
  componentType;
  tripIndex = -1;
  sweepTripsList = null;
  timeZone;
  settingInterval;
  secondaryCompType = null;
  specialRate;
  user;
  cancelTripModalObj;
  isBulkMarkCancel = false;
  isBulkMarkCompleting = false;
  isInprogressBulkActionsVisible = false;
  selectedTrip;
  billerNoteModalObj;
  additionalNoteModalObj;
  tripLogObj;
  checkListObj;
  aiAssistantConversationObj;
  selectedTrips = [];
  orderBy = "scheduleTime";
  toggleActionButtons: boolean = false;
  view = "grid";
  private readonly viewStorageKey = "trips_view_mode";
  selectedDropdownIndex: any;
  tripDetailModalObj;
  completedTripModalObj;
  skip = 0;
  editTripModalObj;
  selectedTripId;
  isAllTripsSelected: boolean = false;

  isShowCms1500 = false;
  associateImageModalObj;
  partialEditModalObj;

  tripPurposesAndAddons;
  selectedTripPurpose = '';
  selectedLOS = [];
  selectedSpaceType = [];
  appointmentTypes;
  selectedAptType = [];
  selectedServiceArea = [];
  patients;
  selectedPatient = [];
  drivers;
  selectedDriver = [];
  driverListMain: any[] = [];
  preDriverList: any = {};
  activeDriverIdMap: { [driverId: string]: boolean } = {};
  selectedDriverMap: { [tripId: string]: string } = {};
  dropdownDriversMap: { [key: string]: { driverId: string; list: any[] } } = {};
  holidayCache: { [corporateId: string]: any[] } = {};
  userRole: string = '';
  cooperates;
  selectedCooperate = [];

  preCooperates:any = {};
  preLevelOfServices = {};
  preSpaceTypes:any = {};
  preServiceAreas = {};
  legTypeMap: any = legTypeMap;
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];
  levelOfServiceList = [];
  filteredLevelOfService = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];
  selectedVehicle = '';
  stationManagerList = [];
  selectedStationManager = [];
  preStaffList = {};
  isAllowRates = false;
  isConfirmationCalls = true;
  isNoShow = false;
  isProduction = environment.production;
  tripPurposesList = [];
  assists: any = [];
  preAssistList = {};

  isfarmoutModal: any;
  farmoutDetails;
  isFarmoutIntegration = false;
  allowPostAdjustment = false;
  templateSaveModalObj;
  cloneTripObj: any;
  routeTrackerObj;
  isStandingOrderChecked: boolean = false;
  isNewRequestChecked: boolean = false;
  isVoiceMailChecked: boolean = false;
  isConfirmedTripChecked: boolean = false;
  isFarmoutChecked: boolean = false;
  isPlannerChecked: boolean = false;
  isStandingOrderClone: boolean = false;
  willCallObj;
  isManual = false;
  outBoundNumber;
  isMarketPlace = false;
  preFleetList = {};
  isSmsAllowed = false;
  allowInprogressTripReassign = false;
  lyftDetailsModalObj;
  isAutoFarmoutDispatch = false;
  columnSearches: any = {
    patient: '',
    phone: '',
    puDate: '',
    puTime: '',
    doTime: '',
    pickupAddress: '',
    dropoffAddress: '',
    milage: '',
    spaceType: '',
    losAssistType: '',
    escort: '',
    driver: '',
    assist: '',
    tripId: '',
    fundingSource: '',
    serviceArea: '',
    specialRate: '',
    appointmentType: '',
    changeReason: '',
    dvNotes: '',
    createdBy: '',
  };
  sortColumn = '';
  sortDirection: 'asc' | 'desc' | '' = '';
  timeFormat: string = 'HHmm';
  advanceOnscene: any = null;
  editTaxiRideModalObj: any;
  confirmationCallURL: string = '';
  bulkCallReviewGroups: any = null;
  bulkActionsTrips: any[] = null;

  /** Inline schedule/appointment time editing (card view + table view). `meridiem` is only used
   * when the company's timeFormat is 12-hour ('hh:mm A') — it tracks the AM/PM toggle for the field
   * currently being edited, independent of the digits typed into the hour/minute input. */
  editingTimeField: { tripId: string; field: 'scheduleTime' | 'appointmentTime'; meridiem?: 'AM' | 'PM' } | null = null;
  /** Tracked via (mouseenter)/(mouseleave) rather than CSS :hover — when a field finishes saving, the
   * resting span re-renders at the exact same screen position the pointer never left, so CSS :hover would
   * light back up instantly with no real "hover" having happened. mouseenter only fires on actual pointer
   * movement, so this only turns on once the user genuinely moves the mouse again. */
  private hoveredTimeField: { tripId: string; field: 'scheduleTime' | 'appointmentTime' } | null = null;
  private inlineTimeDebounceTimers: { [key: string]: any } = {};
  /** Fields that just saved successfully — each briefly flashes green in place instead of a toast.
   * Keyed like inlineTimeDebounceTimers ("tripId_field") since a schedule-time save can flash both
   * fields at once (updating the dropoff time along with it). */
  private justSavedFields = new Set<string>();
  private justSavedFieldTimers: { [key: string]: any } = {};
  /** Keyed "tripId_field" — timestamp until which a hover-enter on that field's resting span is ignored.
   * See onTimeHoverEnter for why this exists. */
  private hoverSuppressedUntil: { [key: string]: number } = {};
  /** Trip + field whose update-trip API call is currently in flight — drives the "Saving…" indicator. */
  savingTripId: string | null = null;
  private savingField: 'scheduleTime' | 'appointmentTime' | null = null;
  isClearFiltersOnAction = false;

  constructor(
    private assistService: AssistService,
    private reportService: ReportService,
    private cms1500Service: Cms1500Service,
    private assignTripService: AssigTripsService,
    private dispatchCenterService: DispatchCenterService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private menuService: MenuService,
    private csvService: CsvService,
    private toastr: ToastrService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private staffService: StaffService,
    private farmoutService: FarmoutService,
    private fleetService: FleetService,
    private tripPurposesService: TripPurposesService,
    private sweetAlertService: SweetAlertService,
    private router: Router,
    private holidayService: HolidayService
  ) { }

  ngOnInit() {
    this.loadSavedView();
    this.getTripPurpose()
    this.getCorporate();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getServiceAreas();
    this.getFleetList();
    this.getUser();
    this.listenSocket();
    this.getStaffList();
    this.getAssisData();

  }

  loadSavedView() {
    const savedView = localStorage.getItem(this.viewStorageKey);
    if (savedView === "list" || savedView === "grid") {
      this.view = savedView;
    }
  }

  setView(view: "list" | "grid") {
    this.view = view;
    localStorage.setItem(this.viewStorageKey, view);
  }



  // Shift + V toggles bulk complete/cancel on the In Progress tab
  @HostListener('document:keydown', ['$event'])
  onInprogressBulkActionsShortcut(event: KeyboardEvent) {
    if (this.status !== 'inprogress' || event.repeat) return;
    if (!event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) return;
    const key = event.key ? event.key.toLowerCase() : '';
    if (key !== 'v' && event.code !== 'KeyV') return;
    const target = event.target as HTMLElement;
    if (target && (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) || target.isContentEditable)) return;
    event.preventDefault();
    this.isInprogressBulkActionsVisible = !this.isInprogressBulkActionsVisible;
  }

  setTripStatus(status, isSkipCheck?) {
    if (!isSkipCheck && this.status === status) return;
    this.isInprogressBulkActionsVisible = false;
    this.skip = 0;
    this.clearTrips();
    this.selectedDropdownIndex = -1;
    this.status = status;
    if (this.isClearFiltersOnAction) {
      // Options are rebuilt from the new tab's trips by generateFilterOptions() in getTrips()
      this.clearDropdownFilters();
    }
    Object.keys(this.columnSearches).forEach((key) => {
      this.columnSearches[key] = '';
    });
    this.sortColumn = '';
    this.sortDirection = '';
    this.getTrips();
    this.reset();
  }

  reset() {
    this.selectedTrips = [];
    this.orderBy = "scheduleTime";
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getDriverList() {
    if (!this.user || !this.user._id) {
      return;
    }
    if (this.driverListMain && this.driverListMain.length) {
      return;
    }
    this.driverService
      .getDrivers(this.user._id, "", true)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
              data = data.filter((item) => item.stationManager === this.user.sId);
            }
            this.driverListMain = data;
            this.activeDriverIdMap = {};
            for (let i = 0; i < data.length; i++) {
              this.activeDriverIdMap[data[i]._id] = true;
            }
          }
        },
        (err) => {
          console.error("Error fetching active drivers", err);
        }
      );
  }

  getDropdownDrivers(assign: any): any[] {
    if (!this.driverListMain || !this.driverListMain.length) {
      if (assign && assign.driver) {
        if (typeof assign.driver === 'object' && assign.driver._id) {
          return [assign.driver];
        }
      }
      return [];
    }
    if (!assign || !assign.driver) {
      return this.driverListMain;
    }
    let assignedId = null;
    let driverObj = null;
    if (typeof assign.driver === 'object' && assign.driver._id) {
      assignedId = assign.driver._id;
      driverObj = assign.driver;
    } else if (typeof assign.driver === 'string') {
      assignedId = assign.driver;
      driverObj = this.preDriverList ? this.preDriverList[assignedId] : null;
    }
    if (!assignedId) {
      return this.driverListMain;
    }
    if (this.activeDriverIdMap && this.activeDriverIdMap[assignedId]) {
      return this.driverListMain;
    }
    const tripKey = assign._id || 'temp';
    const cached = this.dropdownDriversMap[tripKey];
    if (cached && cached.driverId === assignedId) {
      return cached.list;
    }
    const list = driverObj ? [driverObj, ...this.driverListMain] : this.driverListMain;
    this.dropdownDriversMap[tripKey] = {
      driverId: assignedId,
      list: list
    };
    return list;
  }

  onClearRowDriver(assign: any) {
    if (!assign) {
      return;
    }
    const currentDriverId = (assign.driver && assign.driver._id)
      ? assign.driver._id
      : (typeof assign.driver === 'string' ? assign.driver : null);

    if (!currentDriverId) {
      this.selectedDriverMap[assign._id] = null;
      return;
    }

    sweetAlert(
      'Alert',
      'Are you sure you want to unassign this trip?',
      'warning',
      'Yes',
      'No'
    ).then((result: any) => {
      if (result && result.value) {
        this.executeUnassignTrip(assign);
      } else {
        setTimeout(() => {
          this.selectedDriverMap[assign._id] = currentDriverId;
        }, 0);
      }
    });
  }

  getCorporateHolidays(corporateId: string): Observable<any> {
    if (this.holidayCache[corporateId]) {
      return of(this.holidayCache[corporateId]);
    }
    return this.holidayService.getHolidaysByCooperate({ cooperate: corporateId }).pipe(
      tap((data: any) => {
        if (data) {
          this.holidayCache[corporateId] = data;
        }
      })
    );
  }

  checkHolidayForTrip(trip: any, holidays: any[]): any[] {
    const tripScheduleTime = moment(trip.scheduleTime).tz(this.timeZone || 'America/New_York');
    const holidayDays = [];
    if (holidays && holidays.length) {
      for (let i = 0; i < holidays.length; i++) {
        const holiday = holidays[i];
        const holidayStart = moment(holiday.startTime).tz(this.timeZone || 'America/New_York').startOf('day');
        const holidayEnd = moment(holiday.endTime).tz(this.timeZone || 'America/New_York').endOf('day');
        if (tripScheduleTime.isBetween(holidayStart, holidayEnd)) {
          holidayDays.push(holiday.name);
        }
      }
    }
    return holidayDays;
  }

  async onSelectRowDriver(assign: any, event: any) {
    if (!event) {
      return;
    }
    const prevDriverId = (assign.driver && assign.driver._id)
      ? assign.driver._id
      : (typeof assign.driver === 'string' ? assign.driver : null);

    const driverId = (typeof event === 'object' && event._id) ? event._id : event;
    const driver = (this.preDriverList && this.preDriverList[driverId]) ? this.preDriverList[driverId] : event;
    if (!driver) {
      this.selectedDriverMap[assign._id] = prevDriverId;
      return;
    }

    if (driver.hasCheckout || (driver.timeline && driver.timeline.hasCheckout)) {
      sweetAlert('Warning', `${driver.displayName}'s shift has already ended.`, 'warning', 'OK');
      this.selectedDriverMap[assign._id] = prevDriverId;
      return;
    }

    let isOvertimeViolation = false;
    if (this.user && this.user.isManagerAuthorization && ['Restricted (RM,SM,ASM)', 'Dispatcher Manager', 'Full Access'].indexOf(this.userRole) === -1) {
      isOvertimeViolation = hasOvertimeViolation(assign, driver.shift, moment(assign.scheduleTime).tz(this.timeZone).toISOString(), this.timeZone);
    }

    if (isOvertimeViolation) {
      sweetAlertWithInput(
        "Alert",
        `${driver.displayName} has exceeded the allowed working hours. Are you sure you want to assign this trip?`,
        "warning",
        "Yes, Assign",
        "No",
        true,
        "Min. 10 characters.",
        isOvertimeViolation,
        this.user
      ).then((result: any) => {
        if (result && result.value) {
          const overTimeReason = result.value.note;
          this.validateHolidaysAndAssign(assign, driver, overTimeReason, prevDriverId);
        } else {
          this.selectedDriverMap[assign._id] = prevDriverId;
        }
      });
    } else {
      this.validateHolidaysAndAssign(assign, driver, '', prevDriverId);
    }
  }

  validateHolidaysAndAssign(assign: any, driver: any, overTimeReason: string, prevDriverId: any) {
    if (assign.cooperate) {
      this.getCorporateHolidays(assign.cooperate)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (holidays: any) => {
            if (holidays && holidays.length) {
              const resdays = this.checkHolidayForTrip(assign, holidays);
              if (resdays && resdays.length) {
                sweetAlert(
                  'Alert',
                  `Member may be unavailable due to ${resdays.toString()}. Please confirm before assigning the trip. `,
                  'warning',
                  'Yes, Assign',
                  'No'
                ).then((result: any) => {
                  if (result && result.value) {
                    this.proceedWithRowAssignment(assign, driver, overTimeReason, prevDriverId);
                  } else {
                    this.selectedDriverMap[assign._id] = prevDriverId;
                  }
                });
              } else {
                this.proceedWithRowAssignment(assign, driver, overTimeReason, prevDriverId);
              }
            } else {
              this.proceedWithRowAssignment(assign, driver, overTimeReason, prevDriverId);
            }
          },
          (err: any) => {
            this.proceedWithRowAssignment(assign, driver, overTimeReason, prevDriverId);
          }
        );
    } else {
      this.proceedWithRowAssignment(assign, driver, overTimeReason, prevDriverId);
    }
  }

  async proceedWithRowAssignment(assign: any, driver: any, overTimeReason: string, prevDriverId: any) {
    try {
      const fullDriver: any = await this.driverService.getDriversByID(driver._id).toPromise();
      if (!(fullDriver && fullDriver.fleet)) {
        sweetAlert('Error', `No vehicle associate with '${driver.displayName}'.`, 'warning', 'OK');
        this.selectedDriverMap[assign._id] = prevDriverId;
        return;
      }
    } catch (e) {
      if (!driver.fleet) {
        sweetAlert('Error', `No vehicle associate with '${driver.displayName}'.`, 'warning', 'OK');
        this.selectedDriverMap[assign._id] = prevDriverId;
        return;
      }
    }

    const payload: any = {
      ...assign,
      driver: driver._id,
      status: 'offered',
      jobStatus: 'offered',
      assignThrough: 'panel',
      priority: 0
    };
    delete payload.selectedDriverId;
    if (overTimeReason) {
      payload.overTimeReason = overTimeReason;
    }
    if (assign.status === 'inprogress') {
      payload.isByPassed = true;
    }

    this.assignTripService
      .assignTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            if (this.status === 'unassigned') {
              this.removeTripFromCurrentView(assign._id);
            } else {
              assign.driver = driver;
              assign.status = 'offered';
              assign.jobStatus = 'offered';
              this.selectedDriverMap[assign._id] = driver._id;
              delete this.dropdownDriversMap[assign._id];
            }
            if (this.isClearFiltersOnAction) {
              this.clearDropdownFilters();
            }
            this.skip = 0;
            this.getTrips();
          }
        },
        (err: any) => {
          sweetAlert('Error', err, 'warning', 'OK');
          this.selectedDriverMap[assign._id] = prevDriverId;
        }
      );
  }

  executeUnassignTrip(assign: any) {
    let driverObj = assign.driver;
    if (typeof driverObj === 'string' && this.preDriverList && this.preDriverList[driverObj]) {
      driverObj = this.preDriverList[driverObj];
    }

    const payload: any = {
      ...assign,
      jobStatus: 'pending',
      status: 'unassigned',
      priority: 0,
      assignThrough: 'panel',
      driver: driverObj
    };
    delete payload.selectedDriverId;
    if (assign.status === 'inprogress') {
      payload.isByPassed = true;
    }

    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            if (this.status !== 'unassigned' && this.status !== 'all') {
              this.removeTripFromCurrentView(assign._id);
            } else {
              assign.driver = null;
              assign.status = 'unassigned';
              assign.jobStatus = 'pending';
              this.selectedDriverMap[assign._id] = null;
              delete this.dropdownDriversMap[assign._id];
            }
            if (this.isClearFiltersOnAction) {
              this.clearDropdownFilters();
            }
            this.skip = 0;
            this.getTrips();
          }
        },
        (err: any) => {
          sweetAlert('Error', err, 'warning', 'OK');
          this.selectedDriverMap[assign._id] = (assign.driver && assign.driver._id)
            ? assign.driver._id
            : (typeof assign.driver === 'string' ? assign.driver : null);
        }
      );
  }

  removeTripFromCurrentView(tripId: string) {
    if (this.filterdataList && this.filterdataList.length) {
      this.filterdataList = this.filterdataList.filter((item: any) => item._id !== tripId);
    }
    if (this.dataList && this.dataList.length) {
      this.dataList = this.dataList.filter((item: any) => item._id !== tripId);
    }
    delete this.dropdownDriversMap[tripId];
    delete this.selectedDriverMap[tripId];
    this.onTripsRemoved([tripId]);
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // Company login
          if (data.isAdvanceOnscene) {
            this.advanceOnscene = data.isAdvanceOnscene;
          }
          else if (data.company && data.company.isAdvanceOnscene) {
            this.advanceOnscene = data.company.isAdvanceOnscene;
          }

          if (data.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = data.isFarmout
          }
          if (data.hasOwnProperty('allowPostAdjustment')) {
            this.allowPostAdjustment = data.allowPostAdjustment;
          }
          this.timeZone = data.timeZone;
          this.isConfirmationCalls = data.company ? data.company.allowConfirmationCalls : data.allowConfirmationCalls;
          this.user = data;
          if (this.user && this.user.roles) {
            if (typeof this.user.roles === 'string') {
              if (this.user.sRoles) {
                this.userRole = this.menuService.getUserRoleTitle(this.user.sRoles);
              } else {
                this.userRole = this.menuService.getUserRoleTitle(this.user.roles);
              }
            } else if (typeof this.user.roles === 'object') {
              this.userRole = this.menuService.getUserRoleTitle(this.user.roles[0]);
            }
          }
          if (data.timeFormat) {
            this.timeFormat = data.timeFormat;
          }
          this.getDriverList();

          // this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getStaffRoles();
          const savedView = localStorage.getItem(this.viewStorageKey);
          if (savedView === "list" || savedView === "grid") {
            this.view = savedView;
          } else if (this.user.hasOwnProperty("isListView") && this.user.isListView) {
            this.view = "list";
          }

          if (this.user.hasOwnProperty("isSms") && this.user.isSms) {
            this.isSmsAllowed = this.user.isSms;
          }

          if (this.user.hasOwnProperty("allowInprogressTripReassign") && this.user.allowInprogressTripReassign) {
            this.allowInprogressTripReassign = this.user.allowInprogressTripReassign;
          }

          if (this.user.hasOwnProperty("isShowCMS1500")) {
            this.isShowCms1500 = this.user.isShowCMS1500;
          }

          if (this.user.hasOwnProperty("outboundNumber")) {
            this.outBoundNumber = this.user.outboundNumber;
          }
          if (this.user.hasOwnProperty("confirmationCallURL") && this.user.confirmationCallURL) {
            this.confirmationCallURL = this.user.confirmationCallURL;
          }

          if (this.user.hasOwnProperty("autoFarmoutDispatch")) {
            this.isAutoFarmoutDispatch = this.user.autoFarmoutDispatch;
          }

          if (this.user.hasOwnProperty("isClearFiltersOnAction")) {
            this.isClearFiltersOnAction = this.user.isClearFiltersOnAction;
          }
          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  getTripPurpose() {
    this.tripPurposesService.getTripPurposesList("active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.tripPurposesList = data;
      })
  }


  getTrips() {
    // this.filterdataList = [];
    // this.dataList = [];
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: this.status,
      date: this.todayDate,
      skip: this.skip,
    };
    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.clearTrips();
          }
          if (data && object.status === this.status) {
            data.forEach((trip) => {
              trip.isWillcall = moment(trip.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
              if (trip.driver && trip.driver._id) {
                this.selectedDriverMap[trip._id] = trip.driver._id;
              } else if (typeof trip.driver === 'string') {
                this.selectedDriverMap[trip._id] = trip.driver;
              } else {
                this.selectedDriverMap[trip._id] = null;
              }
            });
            this.dataList = [...data, ...this.dataList];
            this.filterdataList = this.dataList;
            this.group(true);


            if (data.length) {
              this.skip += data.length;
              this.getTrips();
            } else {
              this.skip = 0;
              if (this.timer && this.status === 'unassigned') {
                if (this.isTimerEnabled)
                  this.timer.start();
              }
              this.generateFilterOptions();

              if (this.status === 'unassigned') {
                this.selectedDriver = [];
                this.selectedStationManager = [];
              }

              console.log('patients', this.patients);
              console.log('selectedPatients', this.selectedPatient);
            }
          } else if (this.timer && this.status === 'unassigned') {
            if (this.isTimerEnabled)
              this.timer.start();
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.dataList = [];
    this.dropdownDriversMap = {};
    this.selectedDriverMap = {};
    this.updateDuplicateTripIds();
  }

  listenSocket() {
    this.socketService
      .addListener(Events.DROP_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          const indexOfDataList = _.findIndex(this.dataList, {
            _id: data.assignId,
          });
          const indexOfFilterdataList = _.findIndex(this.filterdataList, {
            _id: data.assignId,
          });
          if (this.status === 'all') {
            if (indexOfDataList > -1) {
              this.dataList[indexOfDataList].status = 'offered';
              this.dataList[indexOfDataList].jobStatus = 'offered';
              delete this.dataList[indexOfDataList].job;
            }

            if (indexOfFilterdataList > -1) {
              this.filterdataList[indexOfFilterdataList].status = 'offered';
              this.filterdataList[indexOfFilterdataList].jobStatus = 'offered';
              delete this.filterdataList[indexOfDataList].job;
            }
          } else {
            if (indexOfDataList > -1) this.dataList.splice(indexOfDataList, 1);
            if (indexOfFilterdataList > -1) this.filterdataList.splice(indexOfFilterdataList, 1);
            if (indexOfDataList > -1 || indexOfFilterdataList > -1) this.onTripsRemoved([data.assignId]);
          }
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          this.dataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.isMultiLoad = data.assign.isMultiLoad;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isDialysis = data.assign.isDialysis;
              item.isDeadMiles = data.assign.isDeadMiles;
              item.isLastTrip = data.assign.isLastTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
          this.filterdataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.isMultiLoad = data.assign.isMultiLoad;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isDialysis = data.assign.isDialysis;
              item.isDeadMiles = data.assign.isDeadMiles;
              item.isLastTrip = data.assign.isLastTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {

        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
          }

          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  onDateChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();

  const duration = moment.duration(event[1].diff(event[0]));
  const diffInMonths = duration.asMonths();

  if (diffInMonths < 1) {
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];

    this.getTrips();
    return;
  }

  this.todayDate = [];
  sweetAlert(
    "Error",
    "You can only select a date range of up to 30 days.",
    "warning",
    "Ok"
  );
}

  onTimeChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.todayDate = event.toISOString();
    this.todayDate = [
      event[0].toISOString(),
      event[1].toISOString(),
    ];
    this.getTrips();
  }

  onResetTime() {
    this.reset();
    this.skip = 0;
    this.clearTrips();

    this.todayDate = [
      moment(this.todayDate[0]).startOf("day").toISOString(),
      moment(this.todayDate[1]).endOf("day").toISOString(),
    ];

    this.getTrips();
  }

  getTimeRestrictions() {
    return { min: moment(this.todayDate[0]).startOf("day").toISOString(), max: moment(this.todayDate[1]).endOf("day").toISOString() }
  }

  setTripFilter() {
    this.filterTripsByModel();
  }

  // filterByStandingOrders(): void {
  //   console.log('this.isStandingOrderChecked', this.isStandingOrderChecked);
  //   if (this.isStandingOrderChecked) {
  //     this.filterdataList = this.dataList.filter(trip => trip.so);
  //   } else {
  //     this.filterdataList = [...this.dataList];
  //   }
  // }

  filterByStandingOrders() {
    this.filterTripsByModel();
  }

  claimFile(file) {
    let selectedTripIds;

    if (!this.selectedTrips.length)
      selectedTripIds = this.dataList.map((trip) => trip._id);
    else
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)

    let payload = {
      status: this.status,
      _ids: selectedTripIds,
      scheduleTime: this.todayDate,
    };


    if (file === "generateExcelFile") {
      this.assignTripService
        .generateTripsReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    } else if (file === "generateItineraryFile") {
      this.assignTripService
        .generateTripsIntineraryReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    }
  }

  driverMonitoringReport() {
    let selectedTrip;

    if (!this.selectedTrips.length)
      selectedTrip = this.dataList;
    else
      selectedTrip = this.getSelectedTrips();

    let filterTrips = selectedTrip.filter(trip => trip.driver && trip.job && ["completed", "finished", "cancelled"].includes(trip.status))
    if (filterTrips && filterTrips.length) {
      this.csvService.driverMonitoringReport(filterTrips, this.todayDate, this.timeZone)
    }
  }

  getSelectedTrips() {
    return this.dataList
      .filter((trip) => trip.isSelected);

  }

  group(isNotFromButton?) {
    if (this.filterdataList && this.filterdataList.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filterdataList.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filterdataList.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
    this.updateDuplicateTripIds();
  }


  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  setPartialEditModal(trip) {
    this.partialEditModalObj = trip;
  }

  setModalContent(trips, type, ind?) {
    if (trips)
      this.assignModalObj = trips;
    else
      this.assignModalObj = this.getSelectedTrips().map((trip) => trip._id);

    this.secondaryCompType = null;
    if (ind >= 0) {
      this.tripIndex = ind;
    }
    if (type === "companyNote") {
      this.componentType = type;
    } else if (type === "dsr") {
      this.specialRate = JSON.parse(JSON.stringify(this.assignModalObj));
      this.componentType = type;
    } else if (type === "Multiple Assign") {
      this.componentType = type;
      this.secondaryCompType = this.status;
    } else {
      if (this.status === "hanging") {
        this.componentType = "hanging";
      } else if (this.status === "cancelled") {
        this.componentType = "cancelled";
      } else if (this.status === "archived") {
        this.componentType = "archived";
      } else if (this.status === "all") {
        this.componentType = "all";
      } else {
        this.componentType = type;
      }
    }
  }

  markTripPaid(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip paid?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
        };
        params["bankStatus"] = "paid";
        this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
      }
    });
  }

  tripAssignedResponse(tripStatus: string): void {
    // if (tripStatus === 'Trip Assigned' || tripStatus === 'Trip Un Assigned' || tripStatus === 'All Trips Assigned') {
    //   // sweetAlert('Success', tripStatus, 'success', 'OK');
    // } else if (tripStatus !== null) {
    //   sweetAlert('Error', tripStatus, 'error', 'OK');
    // }
    this.selectedTrips = [];
    this.assignModalObj = null;
    // this.clearTrips();
    if (this.isClearFiltersOnAction) {
      this.clearDropdownFilters();
    }
    this.skip = 0;
    this.getTrips();
  }

  onCloseModal(evt) {
    // if (evt) {
    this.assignModalObj = null;
    // }
  }

  verifiedCancelled(trip, ind) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.tripIndex = ind;
        const data = {
          isVerifiedCancelled: !trip.isVerifiedCancelled,
        };
        // this.store.dispatch(new VerifiedCancelledTrip(data, trip._id));
        this.assignTripService
          .verifiedCancelTrip(data, trip._id)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                let tempInd = -1;
                _.find(this.dataList, (item, i) => {
                  if (item._id === this.filterdataList[this.tripIndex]._id) {
                    tempInd = i;
                    return i;
                  }
                });
                this.filterdataList[this.tripIndex].isVerifiedCancelled =
                  !this.filterdataList[this.tripIndex].isVerifiedCancelled;
                // this.dataList[tempInd].isVerifiedCancelled = !this.dataList[tempInd].isVerifiedCancelled;
                tempInd = -1;
              }
              this.tripIndex = -1;
            },
            (err) => {
              this.tripIndex = -1;
            }
          );
      }
    });
  }

  // Select/Un-Select All & Select Single Trip
  onSelectTrip(trip) {
    const index = this.selectedTrips.indexOf(trip._id);
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip._id);
    }
  }

  selectAllTrips() {
    this.filterdataList.forEach((assign) => {
      if (assign.status === "cancelled" && assign.job && assign.job._id) {
        return;
      }
      if (assign.issues && assign.issues.length) {
        return;
      }

      if (assign.isJClone) {
        return;
      }

      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });
    // }

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filterdataList.length;
    return this.isAllTripsSelected;
  }

  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterByColumnSearches();
    this.filterTrips();
    this.updateDuplicateTripIds();
  }

  /**
   * Normalizes a tripId for duplicate comparison by collapsing runs of
   * whitespace into a single space and trimming.  This is necessary because
   * the API returns inconsistent internal spacing (e.g. 1, 2, or 3 spaces
   * between the trip code and the leg designation).  The leg suffix itself
   * (LEG-A vs LEG-B) is preserved so that different legs are NOT treated
   * as duplicates.
   */
  private normalizeTripId(tripId: string): string {
    return tripId.replace(/\s+/g, ' ').trim();
  }

  updateDuplicateTripIds() {
    const counts: { [key: string]: number } = {};
    const duplicates = new Set<string>();

    if (this.filterdataList && this.filterdataList.length) {
      for (let i = 0; i < this.filterdataList.length; i++) {
        const trip = this.filterdataList[i];
        if (trip && trip.tripId) {
          const key = this.normalizeTripId(trip.tripId);
          counts[key] = (counts[key] || 0) + 1;
          if (counts[key] > 1) {
            duplicates.add(key);
          }
        }
      }
    }

    this.duplicateTripIds = duplicates;
  }

  isDuplicate(tripId: any): boolean {
    if (!tripId || !this.duplicateTripIds) {
      return false;
    }
    return this.duplicateTripIds.has(this.normalizeTripId(tripId));
  }

  hasActiveColumnSearches(): boolean {
    return Object.keys(this.columnSearches).some(
      (key) => !!(this.columnSearches[key] && String(this.columnSearches[key]).trim())
    );
  }

  clearColumnSearches() {
    Object.keys(this.columnSearches).forEach((key) => {
      this.columnSearches[key] = '';
    });
    this.search = '';
    this.sortColumn = '';
    this.sortDirection = '';
    this.filterTripsByModel();
  }

  private matchesColumnSearch(value: any, term: string): boolean {
    if (!term || !String(term).trim()) {
      return true;
    }
    if (value === null || value === undefined) {
      return false;
    }
    return String(value).toLowerCase().includes(String(term).trim().toLowerCase());
  }

  private getAssistDisplayNames(trip: any): string {
    if (!trip.attendees || !trip.attendees.length || !this.preAssistList) {
      return '';
    }
    return trip.attendees
      .map((id) => (this.preAssistList[id] && this.preAssistList[id].displayName) || '')
      .filter(Boolean)
      .join(' ');
  }

  private getColumnSearchValue(trip: any, key: string): string {
    switch (key) {
      case 'driver':
        return (trip.driver && trip.driver.displayName) || '';
      case 'assist':
        return this.getAssistDisplayNames(trip);
      case 'fundingSource':
        return (this.preCooperates && this.preCooperates[trip.cooperate] && this.preCooperates[trip.cooperate].displayName) || '';
      case 'serviceArea':
        return (this.preServiceAreas && this.preServiceAreas[trip.serviceArea] && this.preServiceAreas[trip.serviceArea].name) || '';
      case 'spaceType': {
        const los = (this.preLevelOfServices && this.preLevelOfServices[trip.los] && this.preLevelOfServices[trip.los].title) || '';
        const space = (this.preSpaceTypes && this.preSpaceTypes[trip.spaceType] && this.preSpaceTypes[trip.spaceType].title) || '';
        return `${los} ${space}`.trim();
      }
      case 'losAssistType':
      case 'levelOfAssistance':
        return trip.losAssistType || '';
      case 'tripId':
        return trip.tripId || '';
      case 'puDate':
        return trip.scheduleTime
          ? (this.timeZone
              ? moment(trip.scheduleTime).tz(this.timeZone).format('MM/DD/YYYY')
              : moment(trip.scheduleTime).format('MM/DD/YYYY'))
          : '';
      case 'puTime':
        return trip.scheduleTime
          ? (this.timeZone
              ? moment(trip.scheduleTime).tz(this.timeZone).format(this.timeFormat || 'HHmm')
              : moment(trip.scheduleTime).format(this.timeFormat || 'HHmm'))
          : '';
      case 'doTime':
        return trip.appointmentTime
          ? (this.timeZone
              ? moment(trip.appointmentTime).tz(this.timeZone).format(this.timeFormat || 'HHmm')
              : moment(trip.appointmentTime).format(this.timeFormat || 'HHmm'))
          : '';
      case 'patient':
        return (trip.priorityClient && trip.priorityClient.displayName) || '';
      case 'phone':
        return [
          trip.priorityClient && trip.priorityClient.contactNumber,
          trip.priorityClient && trip.priorityClient.cellPhone,
        ]
          .filter(Boolean)
          .join(' ');
      case 'pickupAddress':
        return trip.jobOriginAddress || '';
      case 'dropoffAddress':
        return trip.jobDestinationAddress || '';
      case 'milage':
        return trip.milage != null ? String(trip.milage) : '';
      case 'escort':
        return trip.noOfEscorts != null ? String(trip.noOfEscorts) : '';
      case 'specialRate':
        return trip.preSpecialRate != null ? String(trip.preSpecialRate) : '';
      case 'appointmentType':
        return trip.tripReason ? trip.tripReason.toString() : '';
      case 'changeReason':
        return trip.changeReason || '';
      case 'dvNotes':
        return trip.companyNote || '';
      case 'createdBy':
        return trip.createdBy || '';
      default:
        return '';
    }
  }

  filterByColumnSearches() {
    if (!this.hasActiveColumnSearches()) {
      return;
    }
    this.filterdataList = this.filterdataList.filter((trip) => {
      return Object.keys(this.columnSearches).every((key) => {
        const term = this.columnSearches[key];
        if (!term || !String(term).trim()) {
          return true;
        }
        return this.matchesColumnSearch(this.getColumnSearchValue(trip, key), term);
      });
    });
  }

  filterTrips() {
    this.filterdataList = this.filterdataList.filter(trip => {
      let isDriverExist = true;
      let isManualTrip = true;
      let isMarketPlace = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isServiceAreaExist = true;
      let isAptTypeExist = true;
      let isPatientExist = true;
      let isStaffExist = true;
      let isSoExist = true;
      let isFarmoutExist = true;
      let isPlannerExist = true;
      let isNewRequest = true;
      let isVoiceMail = true;
      let isConfirmedTrip = true;

      if (this.selectedDriver && this.selectedDriver.length) {
        if (trip.driver && trip.driver._id) {
          isDriverExist = this.selectedDriver.includes(trip.driver._id);
        } else {
          isDriverExist = false;
        }
      }
      if (this.isManual) {
        isManualTrip = !trip.rawId
      }
      if (this.isMarketPlace) {
        isMarketPlace = trip.jobStatus === 'marketplaced'
      }

      if (this.selectedStationManager && this.selectedStationManager.length) {
        if (trip.driver && trip.driver.stationManager) {
          isStaffExist = this.selectedStationManager.includes(trip.driver.stationManager);
        } else {
          isStaffExist = false;
        }
      }

      if (this.selectedPatient && this.selectedPatient.length) {
        if (trip.priorityClient && trip.priorityClient.displayName) {
          isPatientExist = this.selectedPatient.includes(trip.priorityClient.displayName);
        } else {
          isPatientExist = false;
        }
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        if (trip.spaceType) {
          isSpaceTypeExist = this.selectedSpaceType.includes(trip.spaceType);
        } else {
          isSpaceTypeExist = false;
        }
      }

      if (this.selectedAptType && this.selectedAptType.length) {
        if (trip.tripReason) {
          isAptTypeExist = trip.tripReason.some(item => this.selectedAptType.includes(item));
        } else {
          isAptTypeExist = false;
        }
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        if (trip.cooperate) {
          isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
        } else {
          isCorporateExist = false;
        }
      }

      if (this.selectedLOS && this.selectedLOS.length) {
        if (trip.los) {
          islosExist = this.selectedLOS.includes(trip.los);
        } else {
          islosExist = false;
        }
      }

      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        if (trip.serviceArea) {
          isServiceAreaExist = this.selectedServiceArea.includes(trip.serviceArea);
        } else {
          isServiceAreaExist = false;
        }
      }

      if (this.isStandingOrderChecked) {
        isSoExist = trip.so
      }

      if (this.isFarmoutChecked) {
        isFarmoutExist = trip.farmout
      }

      if (this.isPlannerChecked) {
        isPlannerExist = trip.assignThrough === 'planner'
      }

      if (this.isNewRequestChecked) {
        isNewRequest = trip.viewStatus && trip.viewStatus === 'created' || false;
      }

      if (this.isVoiceMailChecked) {
        isVoiceMail = trip.isVoiceMail;
      }

      if (this.isConfirmedTripChecked) {
        isConfirmedTrip = trip.isConfirmedTrip;
      }

      if (isDriverExist && isMarketPlace && isManualTrip && isStaffExist && isPatientExist && isSpaceTypeExist && isAptTypeExist && isCorporateExist && islosExist && isServiceAreaExist && isSoExist && isPlannerExist && isFarmoutExist && isNewRequest && isVoiceMail && isConfirmedTrip) {
        return true;
      } else {
        return false;
      }
    });
    this.applyColumnSort();
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filterdataList.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });

    this.selectedTrips = this.selectedTrips.filter(x => !unselectedTrips.includes(x));
    this.isAllTripsSelected = false;
  }

  sendMemberText(singleTrip, isMvt) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send ${isMvt ? 'verification' : 'confirmation'} SMS to members?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationText([singleTrip._id], isMvt);
        } else {
          const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
          this.requestConfirmationText(selectedTrips, isMvt);
        }
      }
    });
  }

  sendMemberCall(singleTrip) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send confirmation Call to member?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationCall(singleTrip);
        }
      }
    });
  }

  async openBulkConfirmationCallModal() {
    if (!this.outBoundNumber) {
      this.toastr.error("Outbound number not available!", "Alert");
      return;
    }
    const grouped = await this.groupMemberTrips();
    if (!grouped) {
      return;
    }
    this.bulkCallReviewGroups = JSON.parse(JSON.stringify(grouped));
  }

  requestBulkConfirmationCall(selectedTrip: any[]) {
    const isEligibleTrip = (trip: any) => !(trip.isConfirmedTrip || trip.isReadyForPickup || trip.isMarkedCancelledTrip || trip.isHumanConfirmed || trip.isVoiceMail || trip.badPhoneNumber) && this.isTodayOrFuture(trip.scheduleTime);

    const eligibileLegsOfSkippedTrips: any[] = [];

    const filteredTrips = selectedTrip.filter((trip: any) => {
      if (isEligibleTrip(trip)) {
        if (trip.legs && trip.legs.length) {
          trip.legs = trip.legs.filter((leg: any) => isEligibleTrip(leg));
        }
        return true;
      }

      if (trip.legs && trip.legs.length) {
        eligibileLegsOfSkippedTrips.push(...trip.legs.filter((leg: any) => isEligibleTrip(leg)));
      }

      return false;
    });

    const tripsToProcess = [...filteredTrips, ...eligibileLegsOfSkippedTrips];

    if (!tripsToProcess.length) {
      return;
    }

    const eligibleTrips = [];
    const tripsWithIssues = [];

    tripsToProcess.forEach(trip => {
      const memberName = trip.priorityClient && trip.priorityClient.displayName;
      const to = trip.priorityClient && trip.priorityClient.contactNumber;
      const pickup = trip.jobOriginAddress;
      const dropoff = trip.jobDestinationAddress;

      const isPickupTimeValid = trip.scheduleTime && moment(trip.scheduleTime).isValid();
      const pickupTime = isPickupTimeValid
        ? moment(trip.scheduleTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
        : "";

      const currentDateTime = moment().tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss");
      const from = this.outBoundNumber;
      const spaceType = this.preSpaceTypes[trip.spaceType] && this.preSpaceTypes[trip.spaceType].title;

      const isAppointmentTimeValid = trip.appointmentTime && moment(trip.appointmentTime).isValid();
      const appointmentTime = isAppointmentTimeValid
        ? moment(trip.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
        : "";

      const tripData: any = {
        _id: trip._id,
        memberName,
        to,
        pickup,
        dropoff,
        pickupTime,
        currentDateTime,
        from,
        spaceType,
        appointmentTime
      };

      if (trip.legs && trip.legs.length) {
        tripData['legs'] = trip.legs.map((leg: any) => leg._id);
      }

      const missingFields = [];
      if (!memberName) missingFields.push('Member Name');
      if (!to) missingFields.push('Contact Number');

      if (!pickup) missingFields.push('Pickup Address');
      if (!dropoff) missingFields.push('Dropoff Address');

      if (!pickupTime) missingFields.push('Pickup Time');
      if (!appointmentTime) missingFields.push('Dropoff Time');
      if (!spaceType) missingFields.push('Space Type');

      if (missingFields.length > 0) {
        tripsWithIssues.push({
          ...tripData,
          tripId: trip.tripId,
          issues: missingFields.join(', ')
        });
      } else {
        eligibleTrips.push(tripData);
      }
    });

    (window as any).copyAllTripIssues = () => this.copyAllTripIssues(tripsWithIssues);

    if (tripsWithIssues.length) {
      const message = eligibleTrips.length > 0
        ? `${tripsWithIssues.length} trip(s) have missing details and were not processed. The remaining ${eligibleTrips.length} trip(s) are being processed.`
        : `${tripsWithIssues.length} trip(s) have missing details and were not processed.`;

      let tableHtml = `
        <p class="mb-3 text-slate-600 font-sans text-center" style="font-size: 13px;">
          ${message}
        </p>
        <div class="mt-4 rounded-lg border border-slate-200 shadow-sm" style="max-height: 250px; overflow-y: auto; display: block;">
          <table class="w-full border-collapse font-sans text-left bg-white" style="font-size: 12px;">
            <thead>
              <tr class="bg-slate-50 border-b-2 border-slate-200">
                <th class="p-2.5 font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap" style="font-size: 10px; width: 45%;">
                  <span style="display: inline-flex; align-items: center; gap: 6px;">
                    MEMBER / ID
                    <button onclick="window.copyAllTripIssues()" class="hover:bg-slate-200" style="display: inline-flex; align-items: center; justify-content: center; padding: 2px; color: #6B7280; background-color: #F1F5F9; border: 1px solid #E2E8F0; border-radius: 4px; cursor: pointer; transition: all 0.2s; outline: none;" title="Copy all details to clipboard">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                    </button>
                  </span>
                </th>
                <th class="p-2.5 font-semibold text-slate-600 uppercase tracking-wider" style="font-size: 10px;">Issues</th>
              </tr>
            </thead>
            <tbody>
      `;

      tripsWithIssues.forEach(t => {
        tableHtml += `
          <tr class="border-b border-slate-100">
            <td class="py-2 px-2.5 align-top whitespace-nowrap">
              ${t.memberName ? `<div class="text-[11px] text-gray-400 font-normal leading-tight">${t.memberName}</div>` : ''}
              <div class="font-semibold text-gray-500 text-[12px] mt-0.5">${t.tripId || 'N/A'}</div>
            </td>
            <td class="py-2 px-2.5 text-gray-500 align-top font-normal">${t.issues}</td>
          </tr>
        `;
      });

      tableHtml += `
            </tbody>
          </table>
        </div>
      `;

      sweetAlertWithHtml(
        "Alert!",
        "",
        "warning",
        "OK",
        tableHtml
      );
    }

    if (!eligibleTrips.length) {
      return;
    }

    const payload = {
      trips: eligibleTrips
    };

    this.assignTripService
      .sendBulkConfirmationCall(payload, this.confirmationCallURL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  handleBulkCallSave(trips) {
    this.requestBulkConfirmationCall(trips);
    this.bulkCallReviewGroups = null;
  }

  openBulkActionsModal() {
    this.bulkActionsTrips = this.getSelectedTrips();
  }

  handleBulkActionsSuccess() {
    this.bulkActionsTrips = null;
    this.selectedTrips = [];
    this.isAllTripsSelected = false;
    this.skip = 0;
    this.getTrips();
  }

  get lookupData() {
    return { spaceTypes: this.preSpaceTypes, cooperates: this.preCooperates };
  }



  copyAllTripIssues(tripsWithIssues) {
    const textToCopy = tripsWithIssues.map(t => `Trip ID: ${t.tripId || 'N/A'}\nIssues: ${t.issues}`).join('\n\n');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.toastr.success('Copied to clipboard!', 'Alert');
      });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.toastr.success('Copied all trip issues to clipboard!', 'Alert');
      } catch (err) {
        console.error('Fallback copy failed', err);
      }
      document.body.removeChild(textArea);
    }
  }

  requestConfirmationText(selectedTrips, isMvt) {
    let payload = { selectedTrips };
    if (isMvt) {
      payload['isMvt'] = true;
    }
    this.assignTripService
      .sendConfirmationText(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Text send to members successfully!",
            "Alert"
          );
          // sweetAlert('Success', 'Confirmation text sent to member successfully', 'success', 'OK');
        }
      });
  }

  requestConfirmationCall(selectedTrips) {
    if (!this.outBoundNumber) {
      this.toastr.error("Outbound number not available!", "Alert");
      return;
    }

    const memberName = selectedTrips.priorityClient && selectedTrips.priorityClient.displayName;
    const to = selectedTrips.priorityClient && selectedTrips.priorityClient.contactNumber;
    const pickup = selectedTrips.jobOriginAddress;
    const dropoff = selectedTrips.jobDestinationAddress;

    const isPickupTimeValid = selectedTrips.scheduleTime && moment(selectedTrips.scheduleTime).isValid();
    const pickupTime = isPickupTimeValid
      ? moment(selectedTrips.scheduleTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
      : "";

    const currentDateTime = moment().tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss");
    const from = this.outBoundNumber;
    const spaceType = this.preSpaceTypes[selectedTrips.spaceType] && this.preSpaceTypes[selectedTrips.spaceType].title;

    const isAppointmentTimeValid = selectedTrips.appointmentTime && moment(selectedTrips.appointmentTime).isValid();
    const appointmentTime = isAppointmentTimeValid
      ? moment(selectedTrips.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
      : "";

    const missingFields = [];
    if (!memberName) missingFields.push('Member Name');
    if (!to) missingFields.push('Contact Number');
    if (!pickup) missingFields.push('Pickup Address');
    if (!dropoff) missingFields.push('Dropoff Address');
    if (!pickupTime) missingFields.push('Pickup Time');
    if (!appointmentTime) missingFields.push('Dropoff Time');
    if (!spaceType) missingFields.push('Space Type');

    if (missingFields.length > 0) {
      sweetAlert(
        "Alert!",
        `This trip has missing details: ${missingFields.join(', ')}.`,
        "warning",
        "OK"
      );
      return;
    }

    let payload = {
      "_id": selectedTrips._id,
      "memberName": memberName,
      "to": to,
      "pickup": pickup,
      "dropoff": dropoff,
      "pickupTime": pickupTime,
      "currentDateTime": currentDateTime,
      "from": from,
      "spaceType": spaceType,
      "appointmentTime": appointmentTime,
    };

    this.assignTripService
      .sendConfirmationCall(payload,this.confirmationCallURL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  adjustTrips() {
    const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
    const payload = { selectedTrips };
    this.assignTripService
      .autoTripAdjustment(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            // sweetAlert('Success', 'Trips adjusted successfully', 'success', 'OK');
          }
        },
        (err) => {
          // this.clearSelection();
        }
      );
  }

  getParseTripList() {
    this.sweepTripsList = [
      {
        _id: "1",
        total: "",
        scraps: [
          {
            _id: "",
            rawId: "",
            created: "",
            type: "",
            company: "",
            jobs: "",
          },
        ],
      },
    ];
    // this.store.dispatch(new GetSweepTripsList());
    this.assignTripService
      .getSweepTripsList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.sweepTripsList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  // **************** ACTIONS ON TRIP ****************
  // Add Biller Note
  addBillerNote(trip, ind) {
    // this.tripIndex = ind;
    this.billerNoteModalObj = trip;
  }

  onBillerNoteAdded(event) {
    if (event) {
      // sweetAlert('Success', 'Biller Note Added Successfully', 'success', 'OK');
      this.billerNoteModalObj = null;
    } else {
      this.billerNoteModalObj = null;
    }
    // this.assignTripService
    //   .addBillerNote(event)
    //   .subscribe(data => {
    //     if (data) {
    //       let tempInd = -1;
    //         _.find(this.dataList, (item, i) => {
    //           if (item._id === this.filterdataList[this.tripIndex]._id) {
    //             tempInd = i;
    //             return i;
    //           }
    //         });
    //         this.filterdataList[this.tripIndex] = this.assignModalObj;
    //         this.dataList[tempInd] = this.assignModalObj;
    //         this.tripIndex = -1;
    //         tempInd = -1;
    //         this.assignModalObj = null;
    //     }
    //   }, err => {
    //     this.tripIndex = -1;
    //     sweetAlert('Error', err, 'error', 'OK');
    //   });
  }

  // Add Additional Note
  addAdditionalNote(trip, idx) {
    this.additionalNoteModalObj = trip;
  }

  onAdditionalNoteAdded(evt) {
    if (evt) {
      // sweetAlert('Success', 'Additional Note Added Successfully', 'success', 'OK');
    }
    this.additionalNoteModalObj = null;
  }

  // Add Special Rates
  addSpecialRates(data) {
    this.assignTripService
      .addSpecialRate(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.dataList[i].customerSpecialRate = data.customerSpecialRate;
                this.dataList[i].specialRate = data.specialRate;
              }
            });
            this.filterdataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.filterdataList[i].customerSpecialRate =
                  data.customerSpecialRate;
                this.filterdataList[i].specialRate = data.specialRate;
              }
            });
            // sweetAlert('Success', 'Trip Special Rate Added Successfully', 'success', 'OK');
          }
          this.closeActionMenu(null);
        },
        (err) => {
          sweetAlert("Error", err, "warning", "OK");
          this.closeActionMenu(null);
        }
      );
  }

  // Calculate Fare
  calculateFare(assign) {
    this.assignTripService
      .calculateFare(assign._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            assign.estimatedSpecialRate = data.totalFare || "";
            sweetAlert(
              "Alert",
              `Are you sure you want to update BSR Fare: $${data.totalFare} of '${assign.priorityClient.displayName}' - ${assign.tripId}`,
              "warning",
              "Yes",
              "No"
            ).then((result: any) => {
              if (result.value) {
                const payload = {
                  ...data,
                  _id: assign._id
                };
                this.updateDriverFare(payload);
              }
            });


          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  // Add Special Rate
  addSpecialRate() {
    this.addSpecialRates(this.specialRate);
    // $('#dsrModal .close').click();
  }

  // Update Job - Mark Ready, Mark VIP, Mark Confirm, Mark Voicemail
  confirmedTrip(assign, assignKey) {
    let params = {
      assignId: assign._id,
    };

    if (!assign[assignKey]) {
      const options = this.tripPurposesList.map((item: any) => ({
        label: item.title,
        value: item.title
      }));

      const defaultOptions = assign.tripReason = assign.tripReason.filter(x => x.trim() !== '');

      this.sweetAlertService
        .openSelectModal('Alert', `Did '${assign.priorityClient.displayName}' confirm the appointment type for this trip?`, options, defaultOptions)
        .then(result => {
          if (result.value) {

            params[assignKey] = true;
            if (result.value.length) {
              const unique = Array.from(new Set(assign.tripReason.concat(result.value)));

              assign['tripReason'] = unique;
              params['tripReason'] = assign['tripReason'];
              this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
            } else {
              this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
            }
          }
        });
    } else {
      params[assignKey] = false;
      this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
    }
  }


  updateJob(assign, assignKey) {
    let params = {
      assignId: assign._id,
    };
    params[assignKey] = !assign[assignKey];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
  }
  sendForAuth(assign) {
    this.cms1500Service.sendForAuthPDF(assign, this.user);
  }

  // Update Job - Mark Ready, Mark VIP, Mark Confirm, Mark Voicemail
  dropTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to drop this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
          changeReason: "Will Do Later",
          driverId: assign.driver._id,
          company: { _id: this.user._id, displayName: this.user.displayName },
        };
        this.socketService.emit(Events.DROP_TRIP, params);
      }
    });
  }

  // Clone Trip
  cloneTrip(id) {
    sweetAlert(
      "Alert",
      "Are you sure you want to clone this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .cloneTrip(id)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                if (this.isClearFiltersOnAction) {
                  this.clearDropdownFilters();
                }
                this.getTrips();
                // sweetAlert('Success', 'Trip Cloned Successfully', 'success', 'OK');
              }
            },
            (err) => {
              sweetAlert("Error", err, "error", "OK");
            }
          );
      }
    });

    // const isConfirmed = confirm('Are you sure you want to clone this trip');
    // if (isConfirmed) {
    //   this.assignTripService
    //     .cloneTrip(id)
    //     .subscribe(data => {
    //       if (data) {
    //         sweetAlert('Success', 'Trip Cloned Successfully', 'success', 'OK');
    //       }
    //     }, err => {
    //       sweetAlert('Error', err, 'error', 'OK');
    //     });
    // }
  }

  cloneTrip2(trip: any) {
    this.cloneTripObj = trip
  }



  // Remove Trip
  cancelTrip(trip, isNoShow?) {
    this.cancelTripModalObj = trip;
    if (isNoShow) {
      this.isNoShow = isNoShow;
    }
  }

  onCancelTrip(evt) {
    if (this.isBulkMarkCancel) {
      this.isBulkMarkCancel = false;
      this.cancelTripModalObj = null;
      if (evt) {
        this.tripAssignedResponse(null);
      }
      return;
    }
    if (evt && evt.isByPassed) {
      // Edit Cancel Reason In Cancelled Tab
      // No need to splice the trip
      this.cancelTripModalObj = null;
      return;
    }
    if (evt) {
      const index = this.filterdataList.findIndex(
        (trip) => trip._id === evt._id
      );
      if (index > -1) {
        this.filterdataList.splice(index, 1);
        this.updateDuplicateTripIds();
        this.onTripsRemoved([evt._id]);
      }
    }
    this.cancelTripModalObj = null;
    this.isNoShow = false;
  }

  editCancelReason(trip) {
    trip.isByPassed = true;
    this.cancelTripModalObj = trip;
  }

  updateDriverFare(payload) {
    this.dispatchCenterService
      .saveDriverFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.filterdataList.forEach((trip) => {
            if (trip._id === payload._id) {
              trip.preSpecialRate = payload.totalFare || "";
            }
          });
          this.selectedTrip = null;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  rejectRide(assign, index) {
    sweetAlert(
      "Alert",
      "Are you sure you want to re-route this Trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.status = "archived";
        this.assignTripService
          .assignTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              const filterIndex = this.filterdataList.findIndex(t => t._id === assign._id);
              const dataIndex = this.dataList.findIndex(t => t._id === assign._id);
              //splice both lists
              if (filterIndex > -1 && dataIndex > -1) {
                this.filterdataList.splice(filterIndex, 1);
                this.dataList.splice(dataIndex, 1);
                this.updateDuplicateTripIds();
                this.onTripsRemoved([assign._id]);
              }
              sweetAlert('Success', 'Trip Re-routed Successfully', 'success', 'OK');
            }
          });
      }
    });
  }

  markCompletedTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to complete this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .markCompletedTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              const filterIndex = this.filterdataList.findIndex(t => t._id === assign._id);
              const dataIndex = this.dataList.findIndex(t => t._id === assign._id);
              if (this.status === 'all') {
                // update trip
                if (filterIndex > -1 && dataIndex > -1) {
                  this.filterdataList[filterIndex].status = data.status
                  this.filterdataList[filterIndex].jobStatus = data.status
                  this.filterdataList[filterIndex].trackId = data.trackId
                  this.dataList[dataIndex].status = data.status;
                  this.dataList[dataIndex].jobStatus = data.status;
                  this.dataList[dataIndex].trackId = data.trackId;
                }
              } else {
                //splice both lists
                if (filterIndex > -1 && dataIndex > -1) {
                  this.filterdataList.splice(filterIndex, 1);
                  this.dataList.splice(dataIndex, 1);
                  this.updateDuplicateTripIds();
                  this.onTripsRemoved([assign._id]);
                }
              }
            }
          });
      }
    });
  }

  getSelectedTripIds() {
    return this.getSelectedTrips().map((trip) => trip._id).filter((id) => !!id);
  }

  markBulkCompleted() {
    const _ids = this.getSelectedTripIds();
    if (!_ids.length) {
      sweetAlert("Error", "Please select trips", "warning", "OK");
      return;
    }
    if (this.isBulkMarkCompleting) return;

    sweetAlert(
      "Alert",
      `Are you sure you want to complete ${_ids.length} selected trip(s)?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.isBulkMarkCompleting = true;
        this.assignTripService
          .markCompletedBulkTrips({ _ids })
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(() => {
            this.isBulkMarkCompleting = false;
            this.tripAssignedResponse(null);
          }, err => {
            this.isBulkMarkCompleting = false;
            sweetAlert("Error", err, "error", "OK");
          });
      }
    });
  }

  markBulkCancelled() {
    const _ids = this.getSelectedTripIds();
    if (!_ids.length) {
      sweetAlert("Error", "Please select trips", "warning", "OK");
      return;
    }
    // Reuses the cancel modal for reason selection; the modal sends the bulk request
    this.isBulkMarkCancel = true;
    this.cancelTripModalObj = _ids;
  }

  cancelCompleted(assign, index) {
    assign.isFinishedCalled = true;
    assign.isByPassed = true;
    this.cancelTripModalObj = assign;
  }

  markDvRequired(assign, index) {
    this.assignTripService
      .updateTrip(assign)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `${assign.isDvRequired ? 'Marked' : 'Un-Marked'} DV Required Successfully`, 'success', 'OK');
        }
      });
  }

  isPaidTrip(assign, index) {
    this.assignTripService
      .updateTrip(assign)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `${assign.takeSignaturesOnly ? 'Marked' : 'Un-Marked'} Is Paid Successfully`, 'success', 'OK');
        }
      });
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  viewFarmoutDetails(trip) {
    this.openfarmoutModal(trip)
  }

  farmoutCancel(trip) {
    this.cancelRideRequest(trip)
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }

  editTrip(assign) {
    const fundingSource = assign.cooperate ? this.preCooperates[assign.cooperate] : null;
    if (fundingSource && fundingSource.companyType === 'taxi') {
      this.editTaxiRideModalObj = assign._id
      return;
    }
    this.editTripModalObj = assign._id;
  }

  onEditTrip(event) {
    if (this.isStandingOrderClone && (event.status == 'standing' || event.jobStatus == 'standing')) {
      this.isStandingOrderClone = false;
      this.editTripModalObj = null;
      return;
    }
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      // const index = this.filterdataList.findIndex(event._id);
      if (
        moment(event.appointmentTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].appointmentTime).format(
          "YYYY-MM-DD"
        ) ||
        moment(event.scheduleTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].scheduleTime).format("YYYY-MM-DD")
      ) {
        // this.clearTrips();
        // this.getTrips();
        this.filterdataList.splice(idx, 1);
        this.onTripsRemoved([event._id]);
      } else {
        event.isWillcall = moment(event.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
        if (event.driver && event.driver._id) {
          this.selectedDriverMap[event._id] = event.driver._id;
        } else if (typeof event.driver === 'string') {
          this.selectedDriverMap[event._id] = event.driver;
        } else {
          this.selectedDriverMap[event._id] = null;
        }
        this.filterdataList[idx] = event;
      }
      this.editTripModalObj = null;
      this.updateDuplicateTripIds();
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.settingInterval);
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);

    Object.keys(this.inlineTimeDebounceTimers).forEach(key => clearTimeout(this.inlineTimeDebounceTimers[key]));
    Object.keys(this.justSavedFieldTimers).forEach(key => clearTimeout(this.justSavedFieldTimers[key]));
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  getStaffRoles() {
    if (this.user && this.user.roles) {
      if (typeof this.user.roles === "string") {
        if (this.user.sRoles)
          this.subMenus = this.menuService.getAssignedSubMenu(this.user.sRoles);
        else
          this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles);
      } else if (typeof this.user.roles === "object") {
        this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles[0]);
      }
    }

    if (this.subMenus && this.subMenus.length) {
      if (this.subMenus[0].value === "all" && this.subMenus.length > 1)
        this.status = this.subMenus[1].value;
      else this.status = this.subMenus[0].value;

      this.getTrips();
    }
  }

  onClearDriver() {
    this.selectedDriver = [];
  }
  onClearCooperate() {
    this.selectedCooperate = [];
  }

  onClearTripPurpose() {
    this.selectedTripPurpose = "";
  }

  onTimerComplete(): void {
    this.timer.init();
    // this.clearTrips();
    this.skip = 0;
    this.getTrips();
  }


  downloadDriverReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generateDriverReport(data);
  }

  corporateReport() {
    let trips;

    if (this.status === 'all' || !this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    const data = {
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generateCorporateReport(data);
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.skip = 0;
      this.getTrips();
    } else {
      this.timer.init();
    }
  }

  getCmsReport(trip) {
    let queryParams = {
      companyType: trip.companyType,
      tripIdentity: trip.tripIdentity,
      type: "triplogs",
    };
    if (trip.cooperate) {
      queryParams["cooperate"] = trip.cooperate._id;
    }
    this.cms1500Service.getCmsReport(queryParams, this.user);
  }


  markRead(assign) {
    if (assign.viewStatus === "returned") return;
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip as acknowledged?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.viewStatus = "";
        assign.dispatchNoteTwo += ` Mark Acknowledged : ${this.user.displayName
          } ${moment().tz(`${this.timeZone}`).format("MM/DD/YY HHmm")}`;
        this.assignTripService
          .assignTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              // sweetAlert('Success', 'Ride Re-routed Successfully', 'success', 'OK');
              this.closeActionMenu(null);
            }
          });
      }
    });
  }

  // updatedJobFee(evt) {
  //   if (this.filterdataList && this.filterdataList.length) {
  //     const selectedTrip = this.filterdataList.find(
  //       (x) => x.job._id === evt.tripId
  //     );
  //     if (
  //       selectedTrip &&
  //       selectedTrip.job &&
  //       selectedTrip.job.driverFareDetail
  //     ) {
  //       selectedTrip.job.driverFareDetail.jobFee = evt.jobFee;
  //     }
  //   }
  // }

  updatedAssociateImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x._id === evt.tripId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updatedCompImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x.job._id === evt.jobId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updateTripData(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find((x) => x._id === evt._id);
      if (selectedTrip) {
        selectedTrip.attachment = evt.attachment;
        selectedTrip.companyNote = evt.companyNote;
        selectedTrip.dispatchNoteTwo = evt.dispatchNoteTwo;
        selectedTrip.jobDestinationAddress = evt.jobDestinationAddress,
          selectedTrip.jobDestinationLatitude = evt.jobDestinationLatitude,
          selectedTrip.jobDestinationLongitude = evt.jobDestinationLongitude,
          selectedTrip.zipCodeDest = evt.zipCodeDest
      }
    }
  }

  attachAssociateImg(trip) {
    this.associateImageModalObj = trip;
  }

  driverGrivenceReport(trip) {
    this.reportService.getDriverGrivenceReport(trip, this.user);
  }

  adjustCompletedTrips() {
    sweetAlert(
      "Alert",
      `Are you sure you want to adjust the trips?`,
      "warning",
      "Yes",
      "No"
    ).then((result) => {
      if (result.value) {
        const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
        const payload = {
          scheduleTime: this.todayDate.toString(),
          selectedTrips
        };
        this.assignTripService
          .adjustCompletedTrips(payload)
          .subscribe((data) => {
            if (data && data.success) {
              if (data.jobIds && data.jobIds.length) {
                this.filterdataList.forEach((trip) => {
                  if (
                    trip.job &&
                    trip.job._id &&
                    data.jobIds.includes(trip.job._id)
                  ) {
                    trip.job.isFareAdjusted = true;
                  }
                });
              }
              this.toastr.success(data.message, "Alert");
            }
          });
      }
    });
  }

  getETA(trip) {
    this.assignTripService
      .getETA(trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          trip.etaMessage = data.etaMessage;
        }
      });
  }

  openTripLog(assign) {
    this.tripLogObj = assign;
  }
  checkListModal(assign) {
    this.checkListObj = assign;
  }

  tripConfirmationReport() {
    let selectedTripIds;

    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds
    }
    this.assignTripService.downloadConfirmationReport(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + '/excel/' + name;
        downloadFile(url, '', name);
      }
    });
  }

  isOver48Hours(createdAt): boolean {
    const createdTime = moment(createdAt);
    const currentTime = moment();
    const differenceInHours = currentTime.diff(createdTime, 'hours');
    return differenceInHours > 48;
  }


  getAssisData() {
    this.assistService.getAllAssists()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assists = data;
          this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      });
  }

  archiveTrip(payload) {
    const params = {
      status: 'archived',
      isByPassed: true
    }
    this.assignTripService
      .archiveTrip(payload, params)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          sweetAlert('Success', 'Trip Updated', 'success', 'OK');
          if (this.isClearFiltersOnAction) {
            this.clearDropdownFilters();
          }
          this.getTrips();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  tripsReport() {
    let selectedTrips;

    if (!this.selectedTrips.length)
      selectedTrips = this.dataList;
    else
      selectedTrips = this.getSelectedTrips();
    const data = {
      selectedTrips,
      timezone: this.timeZone,
      scheduleTime: this.todayDate[0],
      endDate: this.todayDate[1],
      preCooperates: this.preCooperates,
      preLevelOfServices: this.preLevelOfServices,
    };
    this.csvService.generateTripsReport(data);
  }

  prodCheck() {
    if (this.isProduction) {
      const companyId = this.user.company ? this.user.company._id : this.user._id
      if (companyId === '6463be83c60e5d659486581f') {
        return true;
      } else {
        return false;
      }

    }
    else {
      return true
    }
  }

  downloadR2Report() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      // corporate: this.selectedCooperate,
      // driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    // console.log("Trip Data",data);
    // return;
    this.csvService.generateCompletedTripReport(data);
  }

  downloadPassengerReport() {
    const trips = this.getSelectedTrips();
    const data = {
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generatePassengerReport(data);
  }


  downloadCompletedReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      // corporate: this.selectedCooperate,
      // driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    // console.log("Trip Data",data);
    // return;
    this.csvService.generateFinishedReport(data);
  }


  openfarmoutModal(farmoutTrip) {
    if (farmoutTrip.farmout && farmoutTrip.farmout.platform === 'lyft') {
      this.lyftDetailsModalObj = farmoutTrip;
    } else {
      this.farmoutDetails = farmoutTrip
      this.isfarmoutModal = true
    }
  }

  closelyftDetailsModal(evt) {
    this.lyftDetailsModalObj = null;
  }

  cancelRideRequest(trip) {
    const farmoutTrip = trip.farmout;
    const companyId = this.user.company ? this.user.company._id : this.user._id
    sweetAlert('Alert', `Are you sure you want to cancel farmout trip?`, 'warning', 'Yes', 'No')
      .then((result) => {
        if (result.value) {
          this.farmoutService.cancelRideRequest(farmoutTrip.requestId, { company: companyId, platform: farmoutTrip.platform })
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(async (data) => {
              if (data) {

                if (farmoutTrip.platform === "lyft" && data.cancellation_price) {
                  await this.assignTripService.removeTrip({ ...trip, changeReason: "Dispatcher Called", status: "cancelled", jobStatus: "cancelled", isByPassed: true }, trip._id).toPromise()
                }

                const index = this.filterdataList.findIndex(
                  (trip) => trip._id === data._id
                );
                if (index > -1) {
                  this.filterdataList.splice(index, 1);
                  this.onTripsRemoved([data._id]);
                }
                sweetAlert("Success", 'Farmout trip cancel request in process.', "success", "OK");
              }
            }, (err) => {
              sweetAlert("Error", err, "error", "Ok");
            });
        }
      });
  }

  closefarmoutModal(evt) {
    this.isfarmoutModal = evt
  }

  isRdispatcher(assign) {
    let isAllowToView = true;
    if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
      if (assign.driver) {
        isAllowToView = assign.driver.stationManager === this.user.sId;
      }
    }
    return isAllowToView;
  }

  openTemplateSaveModal() {
    let driverMembers = {};
    this.filterdataList.forEach(trip => {
      if (trip.driver) {
        const driver = trip.driver;
        const member = trip.priorityClient;
        if (driverMembers[driver._id]) {
          const storedMemebers = driverMembers[driver._id].members;
          driverMembers[driver._id] = {
            driver: driver,
            members: [...storedMemebers, { _id: trip.client, ...member }]
          }
        } else {
          driverMembers[driver._id] = {
            driver: driver,
            members: [{ _id: trip.client, ...member }]
          }
        }
      }
    });

    const template = [];
    Object.keys(driverMembers).forEach(driverId => {
      let { driver, members } = driverMembers[driverId]
      members = _.uniq(members, '_id').sort();
      template.push({ driver, members });
    })
    this.templateSaveModalObj = template;
  }

  isNotCurrentDateTrip(trip) {
    return isNotCurrentDateTrip(trip, this.timeZone)
  }

  openRouteTracker(trip) {
    this.routeTrackerObj = trip;
  }

  async createStandingOrder(assign) {
    const result = await sweetAlert('Alert', 'Do you want to create standing order?', 'warning', 'Yes', 'No');
    if (result.value) {
      this.editTripModalObj = assign._id;
      this.isStandingOrderClone = true;
    }
  }

  openWillCallModal(trip) {
    this.willCallObj = trip;
  }

  closeWillCallModal(event) {
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      this.filterdataList[idx] = event;
    }
    this.willCallObj = null;
  }

  clearFilter(filter) {
    this[filter] = [];
    this.filterTripsByModel();
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleetList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  onArrivedStatus(trip) {
    let actualPickup, pickupDuration;
    let status = "";

    const { trackInfoJob } = trip.job;
    if (trackInfoJob.jobArrived) {
      if (trackInfoJob.jobArrived.time) {
        actualPickup = moment(trackInfoJob.jobArrived.time).tz(this.timeZone).format("HH:mm a");
        pickupDuration = moment(trip.scheduleTime).diff(moment(trackInfoJob.jobArrived.time));
        pickupDuration = (pickupDuration / 60000).toFixed(0);

        const isEarly = moment(trip.scheduleTime).isAfter(moment(trackInfoJob.jobArrived.time));
        const diff = pickupDuration
        if (isEarly) {
          if (diff <= 15) {
            status = "On Time";
          } else {
            status = "Early";
          }
        } else {
          if (Math.abs(diff) <= 15) {
            status = "On Time";
          } else {
            status = "Late";
          }
        }
      }
    }
    return status;
  }

  onCompletedStatus(trip) {
    let actualDropOff, dropOffDuration;
    let status = "";

    const { trackInfoJob } = trip.job;
    if (trackInfoJob) {
      if (trackInfoJob.jobCompleted) {
        if (trackInfoJob.jobCompleted.time) {
          actualDropOff = moment(trackInfoJob.jobCompleted.time).tz(this.timeZone).format("HH:mm a");
          dropOffDuration = moment(trip.appointmentTime).diff(moment(trackInfoJob.jobCompleted.time))
          dropOffDuration = (dropOffDuration / 60000).toFixed(0)
          const isLate = moment(trip.appointmentTime).isAfter(moment(trackInfoJob.jobCompleted.time));
          const diff = dropOffDuration
          if (isLate) {
            if (diff <= 15) {
              status = "On Time";
            } else {
              status = "Early";
            }
          } else {
            if (Math.abs(diff) <= 15) {
              status = "On Time";
            } else {
              status = "Late";
            }
          }


        }
      }

    }
    return status;
  }

  sendBulkTripConfirmation() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send confirmation SMS to members?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          startDate: this.todayDate[0],
          endDate: this.todayDate[1]
        }
        this.assignTripService
          .sendBulkTripConfirmation(payload)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(data => {
          }, err => {
            sweetAlert('Error', err, 'warning', 'OK');
          });
      }
    });
  }

  assingTripsConditions(assign) {
    let isAllowToView = false;
    if (
      assign.status !== 'finished' &&
      !assign.isJClone &&
      !assign.isSelected &&
      !assign.isBrokerCancelled &&
      assign.issues.length === 0
    ) {
      if (assign.status === 'inprogress') {
        if (this.allowInprogressTripReassign && !assign.farmout) {
          isAllowToView = true;
        }
      } else if (['cancelled', 'archived'].includes(assign.status) && assign.job) {
        isAllowToView = false;
      } else {
        isAllowToView = true;
      }
    }

    return isAllowToView;
  }

  async disableAutoFarmout(assign) {
    const result = await sweetAlert('Alert', 'Do you want to disable auto farmout for this trip?', 'warning', 'Yes', 'No');
    if (!result.value) return;
    this.assignTripService.updateTrip({ _id: assign._id, isAutoFarmoutDisabled: true })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          assign.isAutoFarmoutDisabled = true;
          sweetAlert('Success', 'Auto Farmout Disabled for this trip', 'success', 'OK');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  isValidFarmoutFare(assign) {
    if (!assign.preSpecialRate && !assign.farmout && !assign.farmout.totalFare) return false;
    const rate = assign.preSpecialRate;
    const fare = assign.farmout.totalFare;
    return fare < rate * 0.8;
  }

  openAiAssistantConversation(trip) {
    this.aiAssistantConversationObj = trip;
  }

  isTodayOrFuture(scheduleTime: string): boolean {
    const tripDate = moment.tz(scheduleTime, this.timeZone).startOf('day');
    const today = moment.tz(this.timeZone).startOf('day');

    return tripDate.isSameOrAfter(today);
  }

  sortTrips(column: string) {
    // Map legacy field names to column search keys
    const keyMap: any = {
      scheduleTime: 'puTime',
      appointmentTime: 'doTime',
      milage: 'milage',
      preSpecialRate: 'specialRate',
      levelOfAssistance: 'losAssistType',
    };
    this.sortByColumn(keyMap[column] || column);
  }

  sortByColumn(column: string) {
    if (this.sortColumn === column) {
      if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else if (this.sortDirection === 'desc') {
        this.sortColumn = '';
        this.sortDirection = '';
        this.filterTripsByModel();
        return;
      } else {
        this.sortDirection = 'asc';
      }
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.applyColumnSort();
  }

  applyColumnSort() {
    if (!this.sortColumn || !this.sortDirection || !this.filterdataList || !this.filterdataList.length) {
      return;
    }
    const column = this.sortColumn;
    const direction = this.sortDirection;
    this.filterdataList.sort((a: any, b: any) => {
      let valA = this.getSortValue(a, column);
      let valB = this.getSortValue(b, column);

      if (valA === null || valA === undefined || valA === '') valA = '';
      if (valB === null || valB === undefined || valB === '') valB = '';

      if (typeof valA === 'number' && typeof valB === 'number') {
        if (valA < valB) return direction === 'asc' ? -1 : 1;
        if (valA > valB) return direction === 'asc' ? 1 : -1;
        return 0;
      }

      const strA = String(valA).toLowerCase();
      const strB = String(valB).toLowerCase();
      if (strA < strB) return direction === 'asc' ? -1 : 1;
      if (strA > strB) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  }

  private getSortValue(trip: any, key: string): any {
    switch (key) {
      case 'driver':
        return (trip.driver && trip.driver.displayName) || '';
      case 'assist':
        return this.getAssistDisplayNames(trip);
      case 'fundingSource':
        return (this.preCooperates && this.preCooperates[trip.cooperate] && this.preCooperates[trip.cooperate].displayName) || '';
      case 'serviceArea':
        return (this.preServiceAreas && this.preServiceAreas[trip.serviceArea] && this.preServiceAreas[trip.serviceArea].name) || '';
      case 'spaceType': {
        const los = (this.preLevelOfServices && this.preLevelOfServices[trip.los] && this.preLevelOfServices[trip.los].title) || '';
        const space = (this.preSpaceTypes && this.preSpaceTypes[trip.spaceType] && this.preSpaceTypes[trip.spaceType].title) || '';
        return `${los} ${space}`.trim();
      }
      case 'losAssistType':
      case 'levelOfAssistance':
        return trip.losAssistType || '';
      case 'tripId':
        return trip.tripId || '';
      case 'puDate':
      case 'puTime':
        return trip.scheduleTime ? moment(trip.scheduleTime).valueOf() : 0;
      case 'doTime':
        return trip.appointmentTime ? moment(trip.appointmentTime).valueOf() : 0;
      case 'patient':
        return (trip.priorityClient && trip.priorityClient.displayName) || '';
      case 'phone':
        return (trip.priorityClient && trip.priorityClient.contactNumber) || '';
      case 'pickupAddress':
        return trip.jobOriginAddress || '';
      case 'dropoffAddress':
        return trip.jobDestinationAddress || '';
      case 'milage':
        return trip.milage != null && trip.milage !== '' ? Number(trip.milage) : 0;
      case 'escort':
        return trip.noOfEscorts != null && trip.noOfEscorts !== '' ? Number(trip.noOfEscorts) : 0;
      case 'specialRate':
        return trip.preSpecialRate != null && trip.preSpecialRate !== '' ? Number(trip.preSpecialRate) : 0;
      case 'appointmentType':
        return trip.tripReason ? trip.tripReason.toString() : '';
      case 'changeReason':
        return trip.changeReason || '';
      case 'dvNotes':
        return trip.companyNote || '';
      case 'createdBy':
        return trip.createdBy || '';
      default:
        return this.getColumnSearchValue(trip, key);
    }
  }

  bulkReroute() {
    const selectedTrips = this.getSelectedTrips();
    const eligibleTripsToReroute = selectedTrips.filter((trip) => {
      return ['iehp', 'llci', 'phpca', 'aetna', 'modivcare', 'first', 'medex','awmt'].includes(trip.companyType) && !['cancelled', 'finished', 'inprogress'].includes(trip.status);
    });
    if (eligibleTripsToReroute && eligibleTripsToReroute.length) {
      const payload = {
        selectedTrips: eligibleTripsToReroute.map(trip => trip._id),
        status: 'archived'
      }

      this.assignTripService.assignMultipleTrip(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
           const reroutedIds = eligibleTripsToReroute.map(t => t._id);
            for (let i = this.filterdataList.length - 1; i >= 0; i--) {
              const trip = this.filterdataList[i];
              if (reroutedIds.includes(trip._id)) {
                this.filterdataList.splice(i, 1);
              }
            }
           this.selectedTrips = []
            sweetAlert('Success', 'Trips Rerouted Successfully', 'success', 'OK');
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    }
  }

  isBulkRerouteElligible() {
    const selectedTrips = this.getSelectedTrips();
    return selectedTrips.some((trip) => {
      return ['iehp', 'llci', 'phpca', 'aetna', 'modivcare', 'first', 'medex','awmt'].includes(trip.companyType)
        && !['cancelled', 'finished', 'inprogress'].includes(trip.status);
    });
  }

  editTaxiRide(assign) {
    this.editTaxiRideModalObj = assign._id;
  }

  onEditTaxiRide(event) {
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      // const index = this.filterdataList.findIndex(event._id);
      if (
        moment(event.appointmentTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].appointmentTime).format(
          "YYYY-MM-DD"
        ) ||
        moment(event.scheduleTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].scheduleTime).format("YYYY-MM-DD")
      ) {
        this.filterdataList.splice(idx, 1);
        this.onTripsRemoved([event._id]);
      } else {
        this.filterdataList[idx] = event;
      }
      this.editTaxiRideModalObj = null;
      this.updateDuplicateTripIds();
    }
  }

  isTaxiRide(assign: any) {
    const fundingSource = assign.cooperate ? this.preCooperates[assign.cooperate] : null;
    return !!(fundingSource && fundingSource.companyType === 'taxi');
  }

  async groupMemberTrips() {
    let selectedTrips = this.getSelectedTrips();
    if (this.status === 'all') {
      const eligibleTrips = this.getEligibleTripsForBulkConfirmation(selectedTrips);
      if (eligibleTrips && eligibleTrips.length) {
        selectedTrips = eligibleTrips;  
      } else {
        sweetAlert('Alert', 'Selected trips are not eligible for confirmation call.', 'warning', 'OK');
        return;
      }
    }
    const trips = selectedTrips;
    const memberIds = _.uniq(trips.map(trip => trip.client).filter(client => client));
    let tripsMembers;
    try {
      tripsMembers = await this.getMembersByIds(memberIds);
    } catch (error) {
      tripsMembers = [];
    }
    const tripsMembersMap = tripsMembers.reduce((obj, item) => (obj[item._id] = item, obj), {});

    const groupedTrips = this.groupAndSortTripsV3(trips, tripsMembersMap);
    return groupedTrips
  }

  async getMembersByIds(ids) {
    if (!ids || ids.length === 0) return [];
    const payload = {
      accountStatus: 'active',
      _ids: ids
    };
    const members = await this.assignTripService.getClients(payload).toPromise();
    return members;
  }

  groupAndSortTripsV3(trips, membersMap) {
    const grouped = trips.reduce(function (acc, trip) {
      if (!trip || !trip.priorityClient || !trip.priorityClient.displayName) return acc;

      const member = trip.client ? membersMap[trip.client] : null;
      const displayName = trip.priorityClient.displayName;

      const {
        firstName = '',
        lastName = ''
      } = (member ? member : parseDisplayName(displayName)) || {};

      const fullName = [firstName, lastName]
        .filter(Boolean)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (!fullName) return acc;

      if (!acc[fullName]) {
        acc[fullName] = [];
      }

      acc[fullName].push(trip);
      return acc;
    }, {} as Record<string, any[]>);

    // Convert grouped object to array, sort members alphabetically, and sort trips within each member
    const result = Object.keys(grouped)
      .sort((a, b) => {
        const getLastName = (name: string) => {
          const parts = name.split(' ');
          let lastName = '';
          if (parts.length === 2) {
            lastName = parts[parts.length - 1];
          } else if (parts.length > 2) {
            lastName = parts[1];
          }
          return lastName || '';
        };
        const lastA = getLastName(a);
        const lastB = getLastName(b);

        const lastCompare = lastA.localeCompare(lastB);
        if (lastCompare !== 0) return lastCompare;

        // fallback → full name compare
        return a.localeCompare(b);

        // return a.toLowerCase() < b.toLowerCase() ? -1 : (a.toLowerCase() > b.toLowerCase() ? 1 : 0);
      })
      .map((member) => {
        const legs = grouped[member];

        // Group trips by pickup date for this member
        const groupedByDate = legs.reduce((dateAcc, trip) => {
          if (!trip.scheduleTime) return dateAcc;

          const scheduleMoment = moment(trip.scheduleTime);
          if (!scheduleMoment.isValid()) return dateAcc;

          const dateKey = scheduleMoment.tz(this.user.timeZone).format('MM/DD/YYYY');

          if (!dateAcc[dateKey]) {
            dateAcc[dateKey] = [];
          }

          dateAcc[dateKey].push(trip);

          return dateAcc;
        }, {} as Record<string, any[]>);

        // Convert date groups to sorted array
        const dates = Object.keys(groupedByDate)
          .sort((a, b) => moment(a).diff(moment(b))) // sort dates ascending
          .map(date => {
            const legs = groupedByDate[date];

            // sort trips inside each date by pickup time
            legs.sort((a, b) => {
              const dateA = a.scheduleTime ? moment(a.scheduleTime) : moment('9999-12-31');
              const dateB = b.scheduleTime ? moment(b.scheduleTime) : moment('9999-12-31');
              return dateA.diff(dateB);
            });

            return {
              date,
              legs
            };
          });

        return {
          member,
          dates
        };
      });

    return result;
  }

  getEligibleTripsForBulkConfirmation(trips: any) {
    // only be called if All tab is selected
    return trips.filter((trip: any) => {
      const isTripEligible = ['unassigned', 'offered', 'accepted'].includes(trip.status);
      return isTripEligible;
    });
  }

  // ================= Inline schedule/appointment time editing (card view + table view) =================

  isTripModificationNotAllowed(trip: any): boolean {
    return !!(this.preCooperates && this.preCooperates[trip.cooperate] && this.preCooperates[trip.cooperate].isTripModificationNotAllowed);
  }

  canEditTimes(trip: any): boolean {
    // Inline time editing is only offered for trips that belong to the Unassigned or Assigned menus —
    // i.e. trip.status is 'unassigned' (shown under Unassigned) or 'offered'/'accepted' (shown under
    // Assigned). This is keyed off the trip's own status rather than the currently selected tab so it
    // also works correctly on the 'All' tab, which mixes trips from every status.
    if (!['unassigned', 'offered', 'accepted'].includes(trip.status)) return false;
    return this.isRdispatcher(trip) && !this.isTripModificationNotAllowed(trip);
  }

  onTimeHoverEnter(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    // When a field's resting span is removed and a new one inserted at the same screen position (closing
    // an edit, or a cascade reopening the other field and reflowing this one), some browsers synthesize a
    // mouseenter on the new element purely because it now sits under an unmoved pointer — not because the
    // user actually moved the mouse there. Swallowing hover-enter calls for a brief window right after such
    // a DOM swap filters those out, without adding any perceptible delay to genuine hovering.
    const key = trip._id + '_' + field;
    if (this.hoverSuppressedUntil[key] && Date.now() < this.hoverSuppressedUntil[key]) return;
    this.hoveredTimeField = { tripId: trip._id, field };
  }

  onTimeHoverLeave(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    if (this.hoveredTimeField && this.hoveredTimeField.tripId === trip._id && this.hoveredTimeField.field === field) {
      this.hoveredTimeField = null;
    }
  }

  private isTimeHovered(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    return !!this.hoveredTimeField && this.hoveredTimeField.tripId === trip._id && this.hoveredTimeField.field === field;
  }

  /** Whether the edit affordance (color/cursor/pencil) should show at all for this field right now — false
   * while it's not editable, or while the dropoff field is already highlighted red for being on a
   * different date (that highlight shouldn't compete with the edit affordance). Shared by both views. */
  private isTimeAffordanceVisible(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    if (!this.canEditTimes(trip)) return false;
    if (field === 'appointmentTime' && this.isNotCurrentDateTrip(trip)) return false;
    return true;
  }

  getTimeSpanClasses(trip: any, field: 'scheduleTime' | 'appointmentTime'): string {
    if (!this.isTimeAffordanceVisible(trip, field)) return '';
    let classes = 'cursor-pointer text-main-primary -mx-1 px-1';
    if (this.isTimeHovered(trip, field) && !this.isJustSaved(trip, field)) {
      classes += ' bg-main-primary/10';
    }
    return classes;
  }

  showTimeEditPencil(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    return this.isTimeAffordanceVisible(trip, field) && this.isTimeHovered(trip, field) && !this.isJustSaved(trip, field);
  }

  isInlineEditing(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    return !!this.editingTimeField && this.editingTimeField.tripId === trip._id && this.editingTimeField.field === field;
  }

  startInlineTimeEdit(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    if (!this.canEditTimes(trip)) return;
    // The resting span is about to be removed from under the pointer, and removal doesn't reliably fire
    // mouseleave in every browser — clear it explicitly so the field starts "unhovered" once it reopens.
    this.onTimeHoverLeave(trip, field);
    this.editingTimeField = {
      tripId: trip._id,
      field,
      meridiem: this.isAmPmFormat() ? this.getMeridiemFor(trip, field) : undefined
    };
    // The `autofocus` attribute on the freshly-inserted input isn't reliably honored on repeat edits of
    // the same field (only the first time reliably grabs focus) — without focus, a later click elsewhere
    // never fires a blur event, so the field silently never closes. Focusing explicitly, once the browser
    // has actually painted the new element, makes every edit session behave the same regardless of how
    // many times this field has already been opened.
    setTimeout(() => this.focusInlineTimeInput(trip._id, field));
  }

  private focusInlineTimeInput(tripId: string, field: 'scheduleTime' | 'appointmentTime') {
    const elementId = (field === 'scheduleTime' ? 'inline-sch-time-' : 'inline-apt-time-') + tripId;
    const el = document.getElementById(elementId) as HTMLInputElement | null;
    if (el) {
      el.focus();
      el.select();
    }
  }

  /** True when the company's configured timeFormat is 12-hour ('hh:mm A') rather than 24-hour ('HHmm'/'HH:mm'). */
  isAmPmFormat(): boolean {
    return !!this.timeFormat && /a/i.test(this.timeFormat);
  }

  private getMeridiemFor(trip: any, field: 'scheduleTime' | 'appointmentTime'): 'AM' | 'PM' {
    const val = trip[field];
    return val ? (moment(val).tz(this.timeZone).format('A') as 'AM' | 'PM') : 'AM';
  }

  /** Flips AM/PM for the field currently being edited and saves immediately — a meridiem change is a
   * complete, deliberate edit on its own, not something to debounce like the digit input. */
  toggleMeridiem(trip: any, field: 'scheduleTime' | 'appointmentTime', inputEl: HTMLInputElement) {
    if (!this.editingTimeField || this.editingTimeField.tripId !== trip._id || this.editingTimeField.field !== field) return;
    this.editingTimeField = { ...this.editingTimeField, meridiem: this.editingTimeField.meridiem === 'AM' ? 'PM' : 'AM' };
    this.clearInlineTimeDebounce(trip, field);
    this.saveInlineTime({ target: inputEl }, trip, field);
  }

  /** Removes the inline time input (for either field) so it can't stay focused/open behind a modal opened from the same card/row. */
  closeInlineTimeEdit(trip: any) {
    if (this.editingTimeField && this.editingTimeField.tripId === trip._id) {
      this.editingTimeField = null;
    }
  }

  /** Digits (in the company timezone) to seed the plain text input with when a field opens for editing —
   * 24-hour "HHmm" normally, or 12-hour "hhmm" (paired with the separate AM/PM toggle) when the company's
   * timeFormat is 'hh:mm A'. */
  getInlineTimeInputValue(trip: any, field: 'scheduleTime' | 'appointmentTime'): string {
    const val = trip[field];
    if (!val) return '';
    const time = moment(val).tz(this.timeZone);
    return time.format(this.isAmPmFormat() ? 'hhmm' : 'HHmm');
  }

  /** Strips non-digits as the user types. */
  restrictToDigits(event: any) {
    const input = event.target;
    const cleaned = input.value.replace(/[^0-9]/g, '');
    if (input.value !== cleaned) {
      input.value = cleaned;
    }
  }

  /** Requires exactly 4 digits ("HHmm"/"hhmm") and, in 12-hour mode, a meridiem to resolve them against.
   * Always returns 24-hour {hours, minutes} regardless of input mode, so every caller downstream (the
   * unchanged-value check, the pickup/dropoff sequence check, the scheduleTime->appointmentTime cascade)
   * stays format-agnostic. Returns null if the text — or the hour range for the active mode — isn't valid. */
  private parseInlineTimeInput(value: string, meridiem?: 'AM' | 'PM'): { hours: number; minutes: number } | null {
    if (!value) return null;
    const digits = value.trim().replace(/\D/g, '');
    if (digits.length !== 4) return null;

    let hours = Number(digits.slice(0, 2));
    const minutes = Number(digits.slice(2, 4));
    if (minutes > 59) return null;

    if (this.isAmPmFormat()) {
      if (hours < 1 || hours > 12) return null;
      if (meridiem === 'PM' && hours !== 12) hours += 12;
      if (meridiem === 'AM' && hours === 12) hours = 0;
    } else if (hours > 23) {
      return null;
    }

    return { hours, minutes };
  }

  /** scheduleTime must be strictly before appointmentTime, and vice versa — returns an error message, or null if OK. */
  private getTimeSequenceError(trip: any, field: 'scheduleTime' | 'appointmentTime', newValue: string): string | null {
    const otherField = field === 'scheduleTime' ? 'appointmentTime' : 'scheduleTime';
    const otherValue = trip[otherField];
    if (!otherValue) return null;

    const newMoment = moment(newValue);
    const otherMoment = moment(otherValue);

    if (field === 'scheduleTime' && !newMoment.isBefore(otherMoment)) {
      return 'Pickup time must be before the dropoff time';
    }
    if (field === 'appointmentTime' && !newMoment.isAfter(otherMoment)) {
      return 'Dropoff time must be after the pickup time';
    }
    return null;
  }

  private inlineTimeDebounceKey(trip: any, field: 'scheduleTime' | 'appointmentTime'): string {
    return trip._id + '_' + field;
  }

  private clearInlineTimeDebounce(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    const timerKey = this.inlineTimeDebounceKey(trip, field);
    if (this.inlineTimeDebounceTimers[timerKey]) {
      clearTimeout(this.inlineTimeDebounceTimers[timerKey]);
      delete this.inlineTimeDebounceTimers[timerKey];
    }
  }

  /** Debounced auto-save while the user is still typing. */
  onInlineTimeInput(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime') {
    this.clearInlineTimeDebounce(trip, field);
    const timerKey = this.inlineTimeDebounceKey(trip, field);
    this.inlineTimeDebounceTimers[timerKey] = setTimeout(() => {
      delete this.inlineTimeDebounceTimers[timerKey];
      this.saveInlineTime(event, trip, field);
    }, 2000);
  }

  /** Fired when the input loses focus — saves immediately. */
  onInlineTimeChange(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime') {
    this.clearInlineTimeDebounce(trip, field);
    this.saveInlineTime(event, trip, field);
  }

  /** Rejects the in-progress edit: shows why, snaps the input back to the last known-good value, and closes it. */
  private rejectInlineTimeEdit(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime', message: string) {
    this.toastr.error(message, 'Error');
    event.target.value = this.getInlineTimeInputValue(trip, field);
    this.finishInlineTimeEdit(trip, field);
  }

  private saveInlineTime(event: any, trip: any, field: 'scheduleTime' | 'appointmentTime') {
    const rawValue = (event.target.value || '').trim();
    if (!rawValue) {
      this.rejectInlineTimeEdit(event, trip, field, 'Time cannot be empty');
      return;
    }

    const meridiem = this.isAmPmFormat() && this.editingTimeField && this.editingTimeField.tripId === trip._id && this.editingTimeField.field === field
      ? this.editingTimeField.meridiem
      : undefined;
    const parsed = this.parseInlineTimeInput(rawValue, meridiem);
    if (!parsed) {
      const formatHint = this.isAmPmFormat() ? 'hhmm (e.g. 0230) and select AM/PM' : 'HHmm (e.g. 1430)';
      this.rejectInlineTimeEdit(event, trip, field, 'Invalid time format. Use ' + formatHint);
      return;
    }

    // The edit only changes the hour/minute — the date comes from the field's existing value, keeping the
    // edited time on the same day it was already on.
    const referenceMoment = moment(trip[field]).tz(this.timeZone);

    // Skip if value hasn't changed
    if (referenceMoment.hour() === parsed.hours && referenceMoment.minute() === parsed.minutes) {
      this.finishInlineTimeEdit(trip, field);
      return;
    }

    // Skipped for scheduleTime: it always carries the dropoff time along with it below, so the
    // result is valid by construction — checking against the not-yet-updated old dropoff time here
    // would wrongly block a schedule change the cascade is about to fix anyway.
    const newMoment = referenceMoment.clone().set({ hour: parsed.hours, minute: parsed.minutes, second: 0, millisecond: 0 });
    const newValue = newMoment.toISOString();

    if (field === 'appointmentTime') {
      const sequenceError = this.getTimeSequenceError(trip, field, newValue);
      if (sequenceError) {
        this.rejectInlineTimeEdit(event, trip, field, sequenceError);
        return;
      }
    }

    event.target.value = newMoment.format(this.isAmPmFormat() ? 'hhmm' : 'HHmm');

    // Moving the pickup time carries the dropoff time along with it (pickup + 1 hour), so the two never
    // drift apart. Computed here, but — unlike the old optimistic-update behavior — neither this nor
    // newValue is written to trip/dataList yet; updateTripTime only applies them once the server confirms
    // the change actually persisted.
    const newAppointmentTime = field === 'scheduleTime' ? newMoment.clone().add(1, 'hour').toISOString() : undefined;

    this.updateTripTime(trip, field, newValue, newAppointmentTime);
  }

  /** Same update-trip API used elsewhere in this component (markDvRequired/isPaidTrip). Always collapses the field
   * back to plain text once the API responds — success or failure — so it never stays stuck in edit mode.
   * trip/dataList are only mutated after the server confirms the update — not before the call, and not
   * reverted after a failure, since nothing was changed to revert. */
  private updateTripTime(
    trip: any,
    field: 'scheduleTime' | 'appointmentTime',
    newValue: string,
    newAppointmentTime: string | undefined
  ) {
    this.savingTripId = trip._id;
    this.savingField = field;

    // Only send the field(s) that actually changed — scheduleTime edits also carry appointmentTime along
    // (the cascade above already computed it), everything else is left alone rather than resending the
    // whole trip object.
    const payload: any = { _id: trip._id, [field]: newValue };
    if (field === 'scheduleTime') {
      payload.appointmentTime = newAppointmentTime;
    }

    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          this.clearSavingIndicator(trip._id);
          if (data) {
            trip[field] = newValue;
            if (field === 'scheduleTime') {
              trip.appointmentTime = newAppointmentTime;
            }
            const tripIndex = this.dataList.findIndex((t: any) => t._id === trip._id);
            if (tripIndex !== -1) {
              this.dataList[tripIndex] = { ...this.dataList[tripIndex], scheduleTime: trip.scheduleTime, appointmentTime: trip.appointmentTime };
            }

            this.showFieldSavedFlash(trip._id, field);
            if (field === 'scheduleTime') {
              // The dropoff time moved along with the pickup time (pickup + 1 hour) — flash it too
              // so it's clear both values changed together, not just the one that was directly edited.
              this.showFieldSavedFlash(trip._id, 'appointmentTime');
            }
            this.toastr.success('Time updated successfully', 'Success');
          }
          this.finishInlineTimeEdit(trip, field);
          if (data && field === 'scheduleTime') {
            // Both times are already saved (the dropoff time was carried along above) — reopen the
            // dropoff field in edit mode so the user can review/adjust the auto-computed value.
            // startInlineTimeEdit already takes care of (re)focusing the freshly-inserted input.
            this.startInlineTimeEdit(trip, 'appointmentTime');
          }
        },
        () => {
          this.clearSavingIndicator(trip._id);
          this.toastr.error('Failed to update time', 'Error');
          this.finishInlineTimeEdit(trip, field);
        }
      );
  }

  private clearSavingIndicator(tripId: string) {
    if (this.savingTripId === tripId) {
      this.savingTripId = null;
      this.savingField = null;
    }
  }

  isSavingTime(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    return this.savingTripId === trip._id && this.savingField === field;
  }

  /** Briefly flashes the edited value green in place instead of a toast — draws the eye to exactly what changed. */
  private showFieldSavedFlash(tripId: string, field: 'scheduleTime' | 'appointmentTime') {
    const key = tripId + '_' + field;
    if (this.justSavedFieldTimers[key]) {
      clearTimeout(this.justSavedFieldTimers[key]);
    }

    this.justSavedFields.add(key);

    this.justSavedFieldTimers[key] = setTimeout(() => {
      delete this.justSavedFieldTimers[key];
      this.justSavedFields.delete(key);
    }, 700);
  }

  isJustSaved(trip: any, field: 'scheduleTime' | 'appointmentTime'): boolean {
    return this.justSavedFields.has(trip._id + '_' + field);
  }

  /** Collapses the inline input back to plain text. */
  private finishInlineTimeEdit(trip: any, field: 'scheduleTime' | 'appointmentTime') {
    if (this.editingTimeField && this.editingTimeField.tripId === trip._id && this.editingTimeField.field === field) {
      this.editingTimeField = null;
    }
    this.hoverSuppressedUntil[trip._id + '_' + field] = Date.now() + 250;
  }

  /** Builds the dropdown filter options (member, space type, driver, etc.) from the trips in dataList. */
  generateFilterOptions() {
    this.drivers = [];
    this.stationManagerList = [];
    let cooperates = [];
    this.tripPurposesAndAddons = [];
    let levelOfServices = [];
    let spaceTypes = [];
    let serviceAreas = [];
    this.appointmentTypes = [];
    this.patients = [];
    this.dataList.forEach(trip => {

      if (trip.driver) {
        this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName });
      }
      if (trip.driver && trip.driver.stationManager) {
        this.stationManagerList.push(trip.driver.stationManager);
      }
      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }

      // if (trip.tripReason) {
      //   // remove the item having empty string
      //   const reasons = trip.tripReason.split(',').filter((reason) => reason !== '');
      //   if (reasons && reasons.length) {
      //     this.tripPurposesAndAddons.push(...reasons);
      //   }
      // }

      if (trip.addonServices && trip.addonServices.length) {
        for (let addon of trip.addonServices) {
          this.tripPurposesAndAddons.push(addon.title);
        }
      }

      if (trip.los) {
        levelOfServices.push(trip.los);
      }

      if (trip.spaceType) {
        spaceTypes.push(trip.spaceType);
      }

      if (trip.tripReason) {
        // remove the item having empty string
        if (trip.tripReason && trip.tripReason.length) {
          this.appointmentTypes.push(...trip.tripReason);
        }
      }
      // const zipCode = this.extractZipCode(trip.jobOriginAddress)
      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }
      if (trip.priorityClient) {
        this.patients.push({ displayName: trip.priorityClient.displayName });
      }
    });


    if (this.selectedLOS && this.selectedLOS.length)
      levelOfServices.push(this.selectedLOS)

    if (this.selectedSpaceType && this.selectedSpaceType.length)
      spaceTypes.push(this.selectedSpaceType)

    if (this.selectedServiceArea && this.selectedServiceArea.length)
      serviceAreas.push(this.selectedServiceArea)

    if (this.selectedAptType && this.selectedAptType.length)
      this.appointmentTypes.push(this.selectedAptType)

    if (this.selectedPatient && this.selectedPatient.length)
      this.patients.push(...this.selectedPatient.map(displayName => ({ displayName })))



    this.drivers = _.uniq(this.drivers, '_id').sort();
    this.stationManagerList = _.uniq(this.stationManagerList).sort();
    cooperates = _.uniq(cooperates).sort();
    this.tripPurposesAndAddons = [...new Set(this.tripPurposesAndAddons)].sort();
    levelOfServices = _.uniq(levelOfServices).sort();
    spaceTypes = _.uniq(spaceTypes).sort();
    serviceAreas = _.uniq(serviceAreas).sort();
    this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
    this.patients = _.uniq(this.patients, 'displayName').sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));

    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    if (levelOfServices && levelOfServices.length) {
      this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
    }

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
    }

    if (spaceTypes && spaceTypes.length) {
      this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
    }
  }

  clearDropdownFilters() {
    this.selectedPatient = [];
    this.selectedSpaceType = [];
    this.selectedDriver = [];
    this.selectedAptType = [];
    this.selectedStationManager = [];
    this.selectedCooperate = [];
    this.selectedLOS = [];
    this.selectedServiceArea = [];
  }

  /**
   * Called whenever trips are removed from the list in response to an action. When the company's
   * isClearFiltersOnAction flag is on, drops the trips from dataList as well (some actions only splice
   * filterdataList), clears the dropdown filter selections and rebuilds their options from the remaining trips.
   */
  onTripsRemoved(tripIds: string[]) {
    if (!this.isClearFiltersOnAction) {
      return;
    }
    this.dataList = this.dataList.filter((trip: any) => !tripIds.includes(trip._id));
    this.clearDropdownFilters();
    this.generateFilterOptions();
    this.filterTripsByModel();
  }
}
